window.__evosem_ssurl = 'https://shopify.evosem.com';
window.DIAMONDS_API_X_KEY = 'vXp93sLQ2eZm7WYkUFta1NdB8RoCTxgq'

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('evosem-diamond-search')) {

		window.currentCurrencySymbol = Shopify.currencySymbol(Shopify.currency.active, Shopify.locale);
		window.__evosemMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec',];
		window.diamondsLabs = ['GIA', 'IGI',];
		window.diamondsColours = ['K', 'J', 'I', 'H', 'G', 'F', 'E', 'D',];
		window.diamondsClarity = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL',];
		window.diamondsFancyColours = [
			{
				label: 'Yellow',
				value: 'Yellow',
				shortcode: 'yellow',
				colour_code: 'yellow', //Hex colour code here please.
			}, {
				label: 'Pink',
				value: 'Pink',
				shortcode: 'pink',
			}, {
				label: 'Purple',
				value: 'Purple',
				shortcode: 'purple',
				colour_code: 'purple', //Hex colour code here please.
			}, {
				label: 'Blue',
				value: 'Blue',
				shortcode: 'blue',
				colour_code: 'blue', //Hex colour code here please.
			}, {
				label: 'Grey',
				value: 'Grey',
				shortcode: 'grey',
				colour_code: 'grey', //Hex colour code here please.
			}, {
				label: 'Green',
				value: 'Green',
				shortcode: 'green',
				colour_code: 'green', //Hex colour code here please.
			}
		];
		window.diamondsCut = [
			{
				label: 'fair',
				value: 'FAIR',
				shortcode: 'F',
			}, {
				label: 'good',
				value: 'GOOD',
				shortcode: 'G',
			}, {
				label: 'very good',
				value: 'VERY GOOD',
				shortcode: 'VG',
			}, {
				label: 'excellent',
				value: 'EXCELLENT',
				shortcode: 'EX',
			}, {
				label: 'ideal',
				value: 'IDEAL',
				shortcode: 'ID',
			}
		];
		window.diamondsFluorescences = [
			{
				label: 'Very Strong',
				value: 'VERY STRONG',
				shortcode: 'VS',
			},
			{
				label: 'Strong',
				value: 'STRONG',
				shortcode: 'S',
			},
			{
				label: 'Medium',
				value: 'MEDIUM',
				shortcode: 'M',
			},
			{
				label: 'Faint',
				value: 'FAINT',
				shortcode: 'F',
			},
			{
				label: 'None',
				value: 'NONE',
				shortcode: 'N',
			},
		];
		window.diamondsIntensity = [
			{
				label: 'Deep',
				value: 'DEEP',
				shortcode: 'D',
			},
			{
				label: 'Vivid',
				value: 'VIVID',
				shortcode: 'V',
			},
			{
				label: 'Intense',
				value: 'INTENSE',
				shortcode: 'I',
			},
			{
				label: 'Fancy',
				value: 'FANCY',
				shortcode: 'F',
			},
			{
				label: 'Fancy Light',
				value: 'FANCY LIGHT',
				shortcode: 'FL',
			},
			{
				label: 'Light',
				value: 'LIGHT',
				shortcode: 'L',
			},
		];
		window.diamondsSymmetry = [
			{
				label: 'fair',
				value: 'FAIR',
				shortcode: 'F',
			}, {
				label: 'good',
				value: 'GOOD',
				shortcode: 'G',
			}, {
				label: 'very good',
				value: 'VERY GOOD',
				shortcode: 'VG',
			}, {
				label: 'excellent',
				value: 'EXCELLENT',
				shortcode: 'EX',
			}
		];
		window.diamondsPolish = [
			{
				label: 'fair',
				value: 'FAIR',
				shortcode: 'F',
			}, {
				label: 'good',
				value: 'GOOD',
				shortcode: 'G',
			}, {
				label: 'very good',
				value: 'VERY GOOD',
				shortcode: 'VG',
			}, {
				label: 'excellent',
				value: 'EXCELLENT',
				shortcode: 'EX',
			}, {
				label: 'ideal',
				value: 'IDEAL',
				shortcode: 'ID',
			}
		];
		window.diamondsShapes = [
			{
				label: 'round',
				value: 'Round',
				icon: 'round',
			}, {
				label: 'oval',
				value: 'Oval',
				icon: 'oval',
			}, {
				label: 'cushion',
				value: 'Cushion',
				icon: 'cushion',
			}, {
				label: 'princess',
				value: 'Princess',
				icon: 'princess',
			}, {
				label: 'pear',
				value: 'Pear',
				icon: 'pear',
			}, {
				label: 'emerald',
				value: 'Emerald',
				icon: 'emerald',
			}, {
				label: 'marquise',
				value: 'Marquise',
				icon: 'marquise',
			}, {
				label: 'asscher',
				value: 'Asscher',
				icon: 'asscher',
			}, {
				label: 'radiant',
				value: 'Radiant',
				icon: 'radiant',
			}, {
				label: 'heart',
				value: 'Heart',
				icon: 'heart',
			}, {
				label: 'Shield',
				value: 'Shield',
				icon: 'Shield',
			}, {
				label: 'Rose',
				value: 'Rose',
				icon: 'Rose',
			}, {
				label: 'Triangular',
				value: 'Triangular',
				icon: 'Triangular',
			}, {
				label: 'Hexagonal',
				value: 'Hexagonal',
				icon: 'Hexagonal',
			}, {
				label: 'Kite',
				value: 'Kite',
				icon: 'Kite',
			}, {
				label: 'Tapered Baguette',
				value: 'Tapered Baguette',
				icon: 'TaperedBaguette',
			}, {
				label: 'Square Emerald',
				value: 'Square Emerald',
				icon: 'SquareEmerald',
			}, {
				label: 'Briolette',
				value: 'Briolette',
				icon: 'Briolette',
			}, {
				label: 'Half Moon',
				value: 'Half Moon',
				icon: 'HalfMoon',
			}, {
				label: 'European Cut',
				value: 'European Cut',
				icon: 'EuropeanCut',
			},
		];
		window.__shapes = [
			{
				label: 'round',
				value: 'Round',
			}, {
				label: 'oval',
				value: 'Oval',
			}, {
				label: 'cushion',
				value: 'Cushion',
			}, {
				label: 'princess',
				value: 'Princess',
			}, {
				label: 'pear',
				value: 'Pear',
			}, {
				label: 'emerald',
				value: 'Emerald',
			}, {
				label: 'marquise',
				value: 'Marquise',
			}, {
				label: 'asscher',
				value: 'Asscher',
			}, {
				label: 'radiant',
				value: 'Radiant',
			}, {
				label: 'heart',
				value: 'Heart',
			}
		];
		window.__price = { min: 391, max: 5359080, };
		window.__carat = { min: 0.40, max: 22, };
		window.__depth = { min: 0, max: 100, };
		window.__table = { min: 0, max: 100, };
		window.__ratio = { min: 0, max: 100, };

		window.diamondQueryTemplate = `
			query (
				$filter: DiamondFilterInput
				$sort: DiamondSortInput
				$pageSize: Int
				$currentPage: Int
			) {
				diamondInventorySearch(
					filter: $filter
					sort: $sort
					pageSize: $pageSize
					currentPage: $currentPage
				) {
					total_count_all
					total_count
					page_size
					current_page
					items {
						carat
						clarity
						crown_angle
						culet
						cut
						depth
						diamond_video
						diamond_image
						diamondcolor
						dim_depth
						dim_length
						dim_width
						dimensions
						fancy_intensity
						fancycolor
						fluorescence
						gia_report_num
						girdle
						rosi_score
						hca_score
						image
						is_fancy
						is_idealcut
						is_labgrown
						is_returnable
						is_idealplus:is_superidealcut
						lab
						name
						pavilion_angle
						polish
						price
						price_per_carat
						fprice
						qty
						ratio
						shape
						shipping_days
						sku
						small_image
						status
						symmetry
						tabl
						thumbnail
						url_key
						vendor
						vendor_stock_num
					}
				}
			}
		`

		const __formatPrice = (price) => {
			return price;
			// temporarily ignore this function.
			if (price <= 0) return 'Call for price';
			return wNumb({ thousand: ',', mark: '.', decimals: 3, prefix: currentCurrencySymbol }).to(price);
		}

		const __formatNumber = (number) => {
			if(!_.isNumber(number)) return number;
			return wNumb({ thousand: ',', mark: '.', decimals: 0 }).to(number);
		}

		window.__formatPrice = __formatPrice;
		window.__formatNumber = __formatNumber;

		const router = new VueRouter({
			mode: 'history', // Optional: cleaner URLs
		});

		let searchView = new Vue({
			delimiters: ['$[', ']'],
			el: '#evosem-diamond-search',
			router,
			data: {
				storageKeyName: '__rh-v-20-searchparameters',
				reviewsList: [],
				dropHintMessageText: '',
				friendEmailMessageText: '',
				viewingMessageText: '',
				sendingDropHint: false,
				sendingPriceMatch: false,
				sendingFriendEmail: false,
				sendingScheduleRequest: false,
				sendingMakeOffer: false,
				popboxes: {
					drophint: false,
					moreinfo: false,
					emailfriend: false,
					scheduleview: false,
					scheduleview: false,
					certificateInfo: false,
					certificateInfoSingle: false,
					bankWireInfo: false,
					shippingInfo: false,
					pricematch: false,
					makeoffer: false,
				},
				copied: false,
				pathname: null,
				visibleDialogSearchMore: false,
				visibleDialogSearch: null,
				selectedDiamond: null,
				selectedDiamondLoadingMedia: false,
				selectedSingleDiamond: null,
				similarDiamonds: null,
				query: {
					count: 0,
					collectionTotal: '--',
					diamonds: [],
				},
				mountended: false,
				addtobagloading: false,
				ready: false,
				firstload: false,
				loadingSingleDiamondPath: false,
				advancedOptionsOn: false,
				singleDiamondView: false,
				diamondsShapes: window.diamondsShapes,
				displayMode: 'list',
				selectedMediaPreview: 'image',
				selectedMediaSinglePreview: 'image',
				loading_certificate:false,
				searchParams: {
					price: window.__price,
					selectedLaboratory: null,
					is_labgrown: false,
					is_fancy: false,
					fancycolor: window.diamondsFancyColours[0].value,
					is_provenance: false,
					is_idealcut: false,
					is_idealplus: false,
					selectedShape: window.diamondsShapes[0].value,
					orderby: '',
					order: 'desc',
					offset: 0,
					price: window.__price,
				},
				advancedFilterActiveWidgets: ['widget-0002', 'widget-0003','widget-0004'],
				loadingMoreDiamonds: false,
				quickviewProperties: {
					visible: false,
					top: 0,
					left: 0,
				},
				isVisibleMobileFilter: false,
				outOfStockDiamond: null,
				wishlist: [],
			},
			components: {
				'quickview': {
					delimiters: ['$[', ']'],
					props: {
						dataQuery: {
							type: Object,
							default: null,
						},
					},
					data: function () {
						return {
							isMouseOver: 0,
						}
					},
					methods: {
						mouseOver: function (e) {
							this.isMouseOver = !0;
						},
						mouseOut: _.debounce(function (e) {
							this.isMouseOver = 0;
						}, 500),

					},
					template: `
						<div class="quick-view-wrapper" ref="quickViewWrapperRef" :style="{top:(dataQuery.quickviewProperties.top)+'px', left:(dataQuery.quickviewProperties.left-375)+'px', }" v-show="dataQuery.quickviewProperties.visible || isMouseOver" @mouseover="mouseOver" @mouseleave="mouseOut">
							<div class="quick-view-inner">
								<div class="diamond-search-main-preview">
									<div class="diamond-search-main-preview-inner" v-if="dataQuery.firstload && !dataQuery.loadingSingleDiamondPath && dataQuery.selectedDiamond">
										<div class="preview-media">
											<div 
												v-if="dataQuery.selectedDiamond.media.picture" 
												class="image-preview" v-if="dataQuery.selectedMediaPreview === 'image'" 
												:style="{display: dataQuery.selectedMediaPreview === 'image' ? 'block' : 'none'}"
											>
												<div class="inner-image-preview" :style="{backgroundImage: 'url('+dataQuery.selectedDiamond.media.picture+')'}">
													<div class="diamond-badge" v-if="dataQuery.selectedDiamond.is_sparkle && dataQuery.selectedDiamond.is_idealplus !== '1'">
														<img :src="window.icon_brilliance_badge" width="35" />
														<span>RH Ideal</span>
													</div>
													<div class="diamond-badge super-ideal" v-show="dataQuery.selectedDiamond.is_idealplus === '1'">
														<img :src="window.icon_brilliance_badge_yellow" width="35" />
														<span>Super Ideal Cut</span>
													</div>		
													<img :src="dataQuery.selectedDiamond.media.picture" class="w-full" />
												</div>
											</div>
											<div class="center"><small>Sample Image</small></div>
										</div>
										<div class="preview-actions">
											<div><button class="evosem-btn uppercase evosem-text-center full-width fill" @click="dataQuery.addToRing()" :disabled="dataQuery.selectedDiamond.price <= 0">Add to ring</button></div>
											<div><button class="evosem-btn uppercase evosem-text-center full-width" @click="dataQuery.openDiamondSingleView(dataQuery.selectedDiamond, true, false)">See details</button></div>
										</div>
										<div class="preview-datasheet-row">
											<div class="preview-datasheet">
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Carat Weight</span></div> <div class="datasheet-value"><span>$[dataQuery.selectedDiamond.carat]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Shape</span></div> <div class="datasheet-value">
														<span :class="'icon shape-'+dataQuery.selectedDiamond.shape.toLowerCase()"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><use :xlink:href="'#__evosem-shape-'+dataQuery.selectedDiamond.shape.toLowerCase()"></use></svg> </span>
														<span>$[dataQuery.selectedDiamond.shape]</span>
													</div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Color</span></div> <div class="datasheet-value"><span>$[dataQuery.selectedDiamond.diamondcolor ? dataQuery.selectedDiamond.diamondcolor : 'N/A']</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Cut</span></div> <div class="datasheet-value"><span>$[dataQuery.selectedDiamond.cut ? dataQuery.getCutName(dataQuery.selectedDiamond.cut) : dataQuery.getSymmetryName(dataQuery.selectedDiamond.symmetry)]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Clarity</span></div> <div class="datasheet-value"><span>$[dataQuery.selectedDiamond.clarity]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Symmetry</span></div> <div class="datasheet-value"><span>$[dataQuery.getSymmetryName(dataQuery.selectedDiamond.symmetry)]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Polish</span></div> <div class="datasheet-value"><span>$[dataQuery.getPolishName(dataQuery.selectedDiamond.polish)]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Fluorescence</span></div> <div class="datasheet-value"><span>$[dataQuery.getFluorescencesName(dataQuery.selectedDiamond.fluorescence)]</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Origin</span></div> <div class="datasheet-value"><span>$[dataQuery.selectedDiamond.is_labgrown ? 'Lab Created' : 'Natural']</span></div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label">
														<span>Lab</span>
													</div>
													<div class="datasheet-value">
														<span v-if="!['IGI','GIA'].includes(dataQuery.selectedDiamond.lab)">$[dataQuery.selectedDiamond.lab]</span>
														<span v-if="dataQuery.selectedDiamond.lab === 'IGI'">
															<img :src="window.igi_logo_mds" alt="igi" title="IGI" style=" width: 50px; height: auto;" width="50" height="50" loading="lazy" />
														</span>
														<span v-if="dataQuery.selectedDiamond.lab === 'GIA'">
															<img :src="window.gia_logo_mds" alt="gia" title="GIA" style=" width: 60px; height: auto;" width="60" height="60" loading="lazy" />
														</span>
														<div><a href="#" @click="dataQuery.openDropBox('certificateInfo', $event)"><strong>Get Certificate</strong></a></div>
													</div>
												</div>
												<div class="datasheet-row datasheet-row-stock">
													<div class="datasheet-label"><span>Stock Number</span></div> <div class="datasheet-value"><span style="text-transform: none;">$[dataQuery.selectedDiamond.sku]</span></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> 
						</div>
					`
				}
			},
			computed: {
				is_idealcut() {
					return this.searchParams.is_idealcut;
				},
				is_idealplus() {
					return this.searchParams.is_idealplus;
				},
				is_fancy() {
					return this.searchParams.is_fancy;
				},
			},
			watch: {
				is_idealcut(newState, prevState) {

					if(newState) {
						this.searchParams.is_idealplus = false;
						this.updateSearch(true);
					} else if(!newState && !this.searchParams.is_idealplus) {
						this.updateSearch(true);
					}
				},
				is_idealplus(newState, prevState) {
					if(newState) {
						this.searchParams.is_idealcut = false;
					}
					this.updateSearch(true);
				},
				is_fancy(newState, prevState) {

					if(newState) {
						this.searchParams.is_idealplus = false;
					}
					this.updateSearch(true);
				},
			},
			beforeUnmount() {
				window.removeEventListener("popstate", $event => {
					console.log($event)
				});
			},
			mounted: async function () {

				window.addEventListener("popstate", $event => {
					const pathList = [
						'/apps/diamondsearch',
						'/apps/diamondsearch/',
						'/apps/diamondsearch/natural/',
						'/apps/diamondsearch/natural',
						'/apps/diamondsearch/lab-grown-diamonds',
						'/apps/diamondsearch/lab-grown-diamonds/',
						'/apps/diamondsearch/labgrown/',
						'/apps/diamondsearch/labgrown',
						'/apps/diamondsearch/round-cut/',
						'/apps/diamondsearch/oval-cut/',
						'/apps/diamondsearch/cushion-cut/',
						'/apps/diamondsearch/princess-cut/',
						'/apps/diamondsearch/pear-cut/',
						'/apps/diamondsearch/emerald-cut/',
						'/apps/diamondsearch/marquise-cut/',
						'/apps/diamondsearch/asscher-cut/',
						'/apps/diamondsearch/radiant-cut/',
						'/apps/diamondsearch/heart-cut/',
						'/apps/diamondsearch/shield-cut/',
						'/apps/diamondsearch/rose-cut/',
						'/apps/diamondsearch/triangular-cut/',
						'/apps/diamondsearch/hexagonal-cut/',
						'/apps/diamondsearch/kite-cut/',
						'/apps/diamondsearch/tapered-baguette-cut/',
						'/apps/diamondsearch/square-emerald-cut/',
						'/apps/diamondsearch/briolette-cut/',
						'/apps/diamondsearch/half-cut/',
						'/apps/diamondsearch/european-cut/',


						'/apps/diamondsearch/fancycolor/',
						'/apps/diamondsearch/idealcut/',
						'/apps/diamondsearch/idealplus/',
						'/apps/diamondsearch/round-cut',
						'/apps/diamondsearch/oval-cut',
						'/apps/diamondsearch/cushion-cut',
						'/apps/diamondsearch/princess-cut',
						'/apps/diamondsearch/pear-cut',
						'/apps/diamondsearch/emerald-cut',
						'/apps/diamondsearch/marquise-cut',
						'/apps/diamondsearch/asscher-cut',
						'/apps/diamondsearch/radiant-cut',
						'/apps/diamondsearch/heart-cut',
						'/apps/diamondsearch/shield-cut',
						'/apps/diamondsearch/rose-cut',
						'/apps/diamondsearch/triangular-cut',
						'/apps/diamondsearch/hexagonal-cut',
						'/apps/diamondsearch/kite-cut',
						'/apps/diamondsearch/tapered-baguette-cut',
						'/apps/diamondsearch/square-emerald-cut',
						'/apps/diamondsearch/briolette-cut',
						'/apps/diamondsearch/half-cut',
						'/apps/diamondsearch/european-cut',
					]
					if(pathList.includes(window.location.pathname)  && this.singleDiamondView) {
						this.closeDiamondSingleView()
					}
				});


				// this.pathname = location.pathname; //replace the stiring with location.pathname
				this.pathname = '/apps/diamondsearch';

				//Load single diamond from URL if any exists.
				await this.loadSingleDiamond();
				//Load more diamonds when the user reaches the end of the diamond list.
				this.loadMoreDiamondsScroll()

				const _pathName = window.location.pathname.split('/');

				this.mountended = true;				

				setTimeout(async () => {
					//Initialise the sliders.
					window.initialiseSlider();

					//Check the current search parameters versus the loaded from the API.
					fetch(`${window.apiBaseUrl}/diamondsearch/ajax/searchavailablevalues/`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'x-requested-with': 'XMLHttpRequest',
							'Content-Type': 'application/json',
						},
					}).then(res => res.json())
					.then( async data => {

						if(!data.status) return false;
						let absoluteMinPrice = data?.search_panel_data?.price?.min_value < this.searchParams.price.min ? parseFloat(data?.search_panel_data?.price?.min_value) : parseFloat(this.searchParams.price.min),
						absoluteMaxPrice = data?.search_panel_data?.price?.max_value > this.searchParams.price.max ? parseFloat(data?.search_panel_data?.price?.max_value) : parseFloat(this.searchParams.price.max),
						absoluteMinCarat = data?.search_panel_data?.carat?.min_value < this.searchParams.min_carat ? data?.search_panel_data?.carat?.min_value : this.searchParams.min_carat,
						absoluteMaxCarat = data?.search_panel_data?.carat?.max_value > this.searchParams.max_carat ? data?.search_panel_data?.carat?.max_value : this.searchParams.max_carat,
						absoluteMinRatio = data?.search_panel_data?.ratio?.min_value < this.searchParams.min_ratio ? data?.search_panel_data?.ratio?.min_value : this.searchParams.min_ratio,
						absoluteMaxRatio = data?.search_panel_data?.ratio?.max_value > this.searchParams.max_ratio ? data?.search_panel_data?.ratio?.max_value : this.searchParams.max_ratio,
						absoluteMinRosi = data?.search_panel_data?.rosi?.min_value < this.searchParams.min_rosi ? data?.search_panel_data?.rosi?.min_value : this.searchParams.min_rosi,
						absoluteMaxRosi = data?.search_panel_data?.rosi?.max_value > this.searchParams.max_rosi ? data?.search_panel_data?.rosi?.max_value : this.searchParams.max_rosi,
						absoluteMinTable = data?.search_panel_data?.tabl?.min_value < this.searchParams.min_table ? data?.search_panel_data?.tabl?.min_value : this.searchParams.min_table,
						absoluteMaxTable = data?.search_panel_data?.tabl?.max_value > this.searchParams.max_table ? data?.search_panel_data?.tabl?.max_value : this.searchParams.max_table,
						absoluteMinDepth = data?.search_panel_data?.depth?.min_value < this.searchParams.min_depth ? data?.search_panel_data?.depth?.min_value : this.searchParams.min_depth,
						absoluteMaxDepth = data?.search_panel_data?.depth?.max_value > this.searchParams.max_depth ? data?.search_panel_data?.depth?.max_value : this.searchParams.max_depth

						if(absoluteMinPrice && absoluteMaxPrice) {
							absoluteMinPrice = parseInt(absoluteMinPrice * parseFloat(Shopify.currency.rate))
							absoluteMaxPrice = parseInt(absoluteMaxPrice * parseFloat(Shopify.currency.rate))
							priceSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinPrice),
									'40%': [5000 * parseFloat(parseFloat(Shopify.currency.rate)), 1],
									'70%': [10000 * parseFloat(parseFloat(Shopify.currency.rate)), 1],
									'90%': [15000 * parseFloat(parseFloat(Shopify.currency.rate)), 1],
									max: parseFloat(absoluteMaxPrice),
								}
							});
                            priceSlider.noUiSlider.set([parseFloat(absoluteMinPrice),parseFloat(absoluteMaxPrice)]);
							window.__price = { 
								min: parseFloat(absoluteMinPrice),
								max: parseFloat(absoluteMaxPrice),
							};
						}

						if(absoluteMinCarat && absoluteMaxCarat) {
							caratSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinCarat),
									max: parseFloat(absoluteMaxCarat),
								}
							});
                            caratSlider.noUiSlider.set([parseFloat(absoluteMinCarat),parseFloat(absoluteMaxCarat)]);
							window.__carat = { 
								min: parseFloat(absoluteMinCarat),
								max: parseFloat(absoluteMaxCarat),
							};
						}

						if(absoluteMinRatio && absoluteMaxRatio) {
                            ratioSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinRatio),
									max: parseFloat(absoluteMaxRatio),
								}
							});
                            ratioSlider.noUiSlider.set([parseFloat(absoluteMinRatio),parseFloat(absoluteMaxRatio)]);
                            ratioSliderMobile.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinRatio),
									max: parseFloat(absoluteMaxRatio),
								}
							});
                            ratioSliderMobile.noUiSlider.set([parseFloat(absoluteMinRatio),parseFloat(absoluteMaxRatio)]);
							window.__ratio = { 
								min: parseFloat(absoluteMinRatio),
								max: parseFloat(absoluteMaxRatio),
							};
                            this.searchParams.ratio = window.__ratio;
						}

						if(absoluteMinRosi && absoluteMaxRosi) {
							rosiSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinRosi),
									max: parseFloat(absoluteMaxRosi),
								}
							});
                            rosiSlider.noUiSlider.set([parseFloat(absoluteMinRosi),parseFloat(absoluteMaxRosi)]);
							// tableSliderMobile.noUiSlider.updateOptions({
							// 	range: {
							// 		min: parseFloat(absoluteMinRosi),
							// 		max: parseFloat(absoluteMaxRosi),
							// 	}
							// });
                            // tableSliderMobile.noUiSlider.set([parseFloat(absoluteMinRosi),parseFloat(absoluteMaxRosi)]);
							window.__rosi = { 
								min: parseFloat(absoluteMinRosi), 
								max: parseFloat(absoluteMaxRosi),
							};
						}

						if(absoluteMinTable && absoluteMaxTable) {
							tableSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinTable),
									max: parseFloat(absoluteMaxTable),
								}
							});
                            tableSlider.noUiSlider.set([parseFloat(absoluteMinTable),parseFloat(absoluteMaxTable)]);
							tableSliderMobile.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinTable),
									max: parseFloat(absoluteMaxTable),
								}
							});
                            tableSliderMobile.noUiSlider.set([parseFloat(absoluteMinTable),parseFloat(absoluteMaxTable)]);
							window.__table = { 
								min: parseFloat(absoluteMinTable), 
								max: parseFloat(absoluteMaxTable),
							};
						}

						if(absoluteMinDepth && absoluteMaxDepth) {
							depthSlider.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinDepth),
									max: parseFloat(absoluteMaxDepth),
								}
							});
                            depthSlider.noUiSlider.set([parseFloat(absoluteMinDepth),parseFloat(absoluteMaxDepth)]);
							depthSliderMobile.noUiSlider.updateOptions({
								range: {
									min: parseFloat(absoluteMinDepth),
									max: parseFloat(absoluteMaxDepth),
								}
							});
                            depthSliderMobile.noUiSlider.set([parseFloat(absoluteMinDepth),parseFloat(absoluteMaxDepth)]);
							window.__depth = { 
								min: parseFloat(absoluteMinDepth), 
								max: parseFloat(absoluteMaxDepth),
							};
						}

						try {

							const shareParams = await this.getShareParams();
							const urlParams = new URLSearchParams(window.location.search);
	
							if(!shareParams) {
								/*-------------------------------------------------------------------*\
									striclty disapprove the saved setting at the user browser that 
									don't match or fall in the available values from the API. 
								\*-------------------------------------------------------------------*/
	
								const dataSaved = this.getSearchFromLocal();
								this.displayMode = dataSaved.displayMode;
								this.advancedOptionsOn = dataSaved.advancedOptionsOn;
								this.searchParams.selectedShape = dataSaved.shapes;
								this.searchParams.is_fancy = dataSaved.is_fancy;
								this.searchParams.fancycolor = dataSaved.fancycolor;
								this.searchParams.is_provenance = dataSaved.is_provenance;
								this.searchParams.is_labgrown = dataSaved.is_labgrown;
								this.searchParams.is_idealcut = dataSaved.is_idealcut;
								this.searchParams.is_idealplus = dataSaved.is_idealplus;
								this.searchParams.is_rosi_sort = dataSaved.is_rosi_sort;
	
								if (priceSlider) {
									console.log('Data saved...',dataSaved.min_price,dataSaved.max_price)
									priceSlider.noUiSlider.updateOptions({ start: [parseFloat(dataSaved.min_price), parseFloat(dataSaved.max_price)] });
								}
	
								if (caratSlider) {
									caratSlider.noUiSlider.updateOptions({ start: [parseFloat(dataSaved.min_carat), parseFloat(dataSaved.max_carat)] });
								}
	
								if (depthSlider) {
									depthSlider.noUiSlider.updateOptions({ start: [dataSaved.min_depth, dataSaved.max_depth] });
								}
	
								if (depthSliderMobile) {
									depthSliderMobile.noUiSlider.updateOptions({ start: [dataSaved.min_depth, dataSaved.max_depth] });
								}
	
								if (tableSlider) {
									tableSlider.noUiSlider.updateOptions({ start: [dataSaved.min_table, dataSaved.max_table] });
								}

								if (rosiSlider) {
									rosiSlider.noUiSlider.updateOptions({ start: [dataSaved.min_rosi, dataSaved.max_rosi] });
								}
	
								if (tableSliderMobile) {
									tableSliderMobile.noUiSlider.updateOptions({ start: [dataSaved.min_table, dataSaved.max_table] });
								}
	
								if (ratioSlider) {
									ratioSlider.noUiSlider.updateOptions({ start: [dataSaved.min_ratio, dataSaved.max_ratio] });
								}
	
								if (ratioSliderMobile) {
									ratioSliderMobile.noUiSlider.updateOptions({ start: [dataSaved.min_ratio, dataSaved.max_ratio] });
								}
	
								if (claritySlider) {
									const __clarityIndexOfMin = _.findIndex(diamondsClarity, i => i === _.first(dataSaved.clarities.split(','))),
										__clarityIndexOfMax = _.findIndex(diamondsClarity, i => i === _.last(dataSaved.clarities.split(',')));
									claritySlider.noUiSlider.updateOptions({ start: [__clarityIndexOfMin, __clarityIndexOfMax + 1] });
								}
	
								if (colorSlider) {
									const __colorIndexOfMin = _.findIndex(diamondsColours, i => i === _.first(dataSaved.colors.split(','))),
										__colorIndexOfMax = _.findIndex(diamondsColours, i => i === _.last(dataSaved.colors.split(',')));
									colorSlider.noUiSlider.updateOptions({ start: [__colorIndexOfMin, __colorIndexOfMax + 1] });
								}
	
								if (cutSlider) {
									const __cutIndexOfMin = _.findIndex(diamondsCut, i => i.value === _.first(dataSaved.cuts.split(','))),
										__cutIndexOfMax = _.findIndex(diamondsCut, i => i.value === _.last(dataSaved.cuts.split(',')));
									cutSlider.noUiSlider.updateOptions({ start: [__cutIndexOfMin, __cutIndexOfMax + 1] });
								}
	
								if (fluorescenceSliderMobile) {
									const __fluorescenceIndexOfMin = _.findIndex(diamondsFluorescences, i => i.value === _.first(dataSaved.fluorescences.split(','))),
									__fluorescenceIndexOfMax = _.findIndex(diamondsFluorescences, i => i.value === _.last(dataSaved.fluorescences.split(',')));
									fluorescenceSliderMobile.noUiSlider.updateOptions({ start: [__fluorescenceIndexOfMin, __fluorescenceIndexOfMax + 1] });
								}
	
								if (fluorescenceSlider) {
									const __fluorescenceIndexOfMin = _.findIndex(diamondsFluorescences, i => i.value === _.first(dataSaved.fluorescences.split(','))),
									__fluorescenceIndexOfMax = _.findIndex(diamondsFluorescences, i => i.value === _.last(dataSaved.fluorescences.split(',')));
									fluorescenceSlider.noUiSlider.updateOptions({ start: [__fluorescenceIndexOfMin, __fluorescenceIndexOfMax + 1] });
								}
	
								if (intensitySlider) {
									const __intensityIndexOfMin = _.findIndex(diamondsIntensity, i => i.value === _.first(dataSaved.fancyintensity.split(','))),
									__intensityIndexOfMax = _.findIndex(diamondsIntensity, i => i.value === _.last(dataSaved.fancyintensity.split(',')));
									intensitySlider.noUiSlider.updateOptions({ start: [__intensityIndexOfMin, __intensityIndexOfMax + 1] });
								}
	
								if (polishSlider) {
									const __polishIndexOfMin = _.findIndex(diamondsPolish, i => i.value === _.first(dataSaved.polishs.split(','))),
										__polishIndexOfMax = _.findIndex(diamondsPolish, i => i.value === _.last(dataSaved.polishs.split(',')));
									polishSlider.noUiSlider.updateOptions({ start: [__polishIndexOfMin, __polishIndexOfMax + 1] });
								}
	
								if (polishSliderMobile) {
									const __polishIndexOfMin = _.findIndex(diamondsPolish, i => i.value === _.first(dataSaved.polishs.split(','))),
										__polishIndexOfMax = _.findIndex(diamondsPolish, i => i.value === _.last(dataSaved.polishs.split(',')));
										polishSliderMobile.noUiSlider.updateOptions({ start: [__polishIndexOfMin, __polishIndexOfMax + 1] });
								}
	
								if (symmetrySlider) {
									const __symmetryIndexOfMin = _.findIndex(diamondsSymmetry, i => i.value === _.first(dataSaved.symmetrys.split(','))),
										__symmetryIndexOfMax = _.findIndex(diamondsSymmetry, i => i.value === _.last(dataSaved.symmetrys.split(',')));
									symmetrySlider.noUiSlider.updateOptions({ start: [__symmetryIndexOfMin, __symmetryIndexOfMax + 1] });
								}
	
								if (symmetrySliderMobile) {
									const __symmetryIndexOfMin = _.findIndex(diamondsSymmetry, i => i.value === _.first(dataSaved.symmetrys.split(','))),
										__symmetryIndexOfMax = _.findIndex(diamondsSymmetry, i => i.value === _.last(dataSaved.symmetrys.split(',')));
									symmetrySliderMobile.noUiSlider.updateOptions({ start: [__symmetryIndexOfMin, __symmetryIndexOfMax + 1] });
								}
	
							}
	
							if (shareParams) {
	
								if(shareParams.is_fancy) this.searchParams.is_fancy = shareParams.is_fancy;
								if(shareParams.fancycolor) this.searchParams.fancycolor = shareParams.fancycolor;
								if(shareParams.is_provenance) this.searchParams.is_provenance = shareParams.is_provenance;
								if(shareParams.is_labgrown) this.searchParams.is_labgrown = shareParams.is_labgrown;
								if(shareParams.is_idealcut) this.searchParams.is_idealcut = shareParams.is_idealcut;
								if(shareParams.is_idealplus) this.searchParams.is_idealplus = shareParams.is_idealplus;
								if(shareParams.is_rosi_sort) this.searchParams.is_rosi_sort = shareParams.is_rosi_sort;
	
								if(!_.isEmpty(shareParams.selectedShape)) {
									this.searchParams.selectedShape = shareParams.selectedShape
								}
	
								if(!_.isEmpty(shareParams.selectedLaboratory)) {
									this.searchParams.lab = shareParams.selectedLaboratory
								}
	
								if (priceSlider) {
									priceSlider.noUiSlider.updateOptions({ range: { min: parseFloat(shareParams.price.min), max: parseFloat(shareParams.price.max) } });
									this.searchParams.price = {
										min:parseFloat(shareParams.price.min),
										max:parseFloat(shareParams.price.max),
									};
								}
	
								if (caratSlider) {
									caratSlider.noUiSlider.updateOptions({ start: [parseFloat(shareParams.carat.min), parseFloat(shareParams.carat.max)] });
									this.searchParams.carat = shareParams.carat;
								}
	
								if (ratioSlider) {
									ratioSlider.noUiSlider.updateOptions({ start: [parseFloat(shareParams.ratio.min), parseFloat(shareParams.ratio.max)] });
									this.searchParams.ratio = shareParams.ratio;
								}
	
								if (ratioSliderMobile) {
									ratioSliderMobile.noUiSlider.updateOptions({ start: [parseFloat(shareParams.ratio.min), parseFloat(shareParams.ratio.max)] });
									this.searchParams.ratio = shareParams.ratio;
								}
	
								if (tableSlider) {
									tableSlider.noUiSlider.updateOptions({ start: [shareParams.table.min, shareParams.table.max] });
									this.searchParams.table = shareParams.table;
								}

								if (rosiSlider) {
									rosiSlider.noUiSlider.updateOptions({ start: [shareParams.rosi.min, shareParams.rosi.max] });
									this.searchParams.rosi = shareParams.rosi;
								}

								if (tableSliderMobile) {
									tableSliderMobile.noUiSlider.updateOptions({ start: [shareParams.table.min, shareParams.table.max] });
									this.searchParams.table = shareParams.table;
								}
	
								if (depthSlider) {
									depthSlider.noUiSlider.updateOptions({ start: [shareParams.depth.min, shareParams.depth.max] });
									this.searchParams.depth = shareParams.depth;
								}
	
								if (depthSliderMobile) {
									depthSliderMobile.noUiSlider.updateOptions({ start: [shareParams.depth.min, shareParams.depth.max] });
									this.searchParams.depth = shareParams.depth;
								}
	
								if (colorSlider && !_.isEmpty(shareParams.colors)) {
									const __colourIndexOfMin = _.findIndex(diamondsColours, i => i === _.first(shareParams.colors)),
										__colourIndexOfMax = _.findIndex(diamondsColours, i => i === _.last(shareParams.colors));
									colorSlider.noUiSlider.updateOptions({ start: [__colourIndexOfMin, __colourIndexOfMax + 1] });
									this.searchParams.colors = shareParams.colors;
								}
	
								if (fluorescenceSlider && !_.isEmpty(shareParams.fluorescence)) {
									const __fluorescenceIndexOfMin = _.findIndex(diamondsFluorescences, i => i.value === _.first(shareParams.fluorescence).value),
									__fluorescenceIndexOfMax = _.findIndex(diamondsFluorescences, i => i.value === _.last(shareParams.fluorescence).value);
									fluorescenceSlider.noUiSlider.updateOptions({ start: [__fluorescenceIndexOfMin, __fluorescenceIndexOfMax + 1] });
									this.searchParams.fluorescence = shareParams.fluorescence.map( fluorescence => fluorescence.value).join()
								}
	
								if (fluorescenceSliderMobile && !_.isEmpty(shareParams.fluorescence)) {
									const __fluorescenceIndexOfMin = _.findIndex(diamondsFluorescences, i => i.value === _.first(shareParams.fluorescence).value),
									__fluorescenceIndexOfMax = _.findIndex(diamondsFluorescences, i => i.value === _.last(shareParams.fluorescence).value);
									fluorescenceSliderMobile.noUiSlider.updateOptions({ start: [__fluorescenceIndexOfMin, __fluorescenceIndexOfMax + 1] });
								}
	
								if (intensitySlider && !_.isEmpty(shareParams.fancyintensity)) {
									const __intensityIndexOfMin = _.findIndex(diamondsIntensity, i => i === _.first(shareParams.fancyintensity)),
									__intensityIndexOfMax = _.findIndex(diamondsIntensity, i => i === _.last(shareParams.fancyintensity));
									intensitySlider.noUiSlider.updateOptions({ start: [__intensityIndexOfMin, __intensityIndexOfMax + 1] });
									this.searchParams.fancyintensity = shareParams.fancyintensity;
								}
	
								if (claritySlider && !_.isEmpty(shareParams.clarity)) {
									const __clarityIndexOfMin = _.findIndex(diamondsClarity, i => i === _.first(shareParams.clarity)),
										__clarityIndexOfMax = _.findIndex(diamondsClarity, i => i === _.last(shareParams.clarity));
									claritySlider.noUiSlider.updateOptions({ start: [__clarityIndexOfMin, __clarityIndexOfMax + 1] });
									this.searchParams.clarity = shareParams.clarity;
								}
	
								if (cutSlider && !_.isEmpty(shareParams.cut)) {
									const __cutIndexOfMin = _.findIndex(diamondsCut, i => i.value === _.first(shareParams.cut)),
										__cutIndexOfMax = _.findIndex(diamondsCut, i => i.value === _.last(shareParams.cut));
									cutSlider.noUiSlider.updateOptions({ start: [__cutIndexOfMin, __cutIndexOfMax + 1] });
									this.searchParams.cut = shareParams.cut;
								}
	
								if (polishSlider && !_.isEmpty(shareParams.polish)) {
									const __polishIndexOfMin = _.findIndex(diamondsPolish, i => i.value === _.first(shareParams.polish)),
										__polishIndexOfMax = _.findIndex(diamondsPolish, i => i.value === _.last(shareParams.polish));
									polishSlider.noUiSlider.updateOptions({ start: [__polishIndexOfMin, __polishIndexOfMax + 1] });
									this.searchParams.polish = shareParams.polish;
								}
	
								if (polishSliderMobile && !_.isEmpty(shareParams.polish)) {
									const __polishIndexOfMin = _.findIndex(diamondsPolish, i => i.value === _.first(shareParams.polish)),
										__polishIndexOfMax = _.findIndex(diamondsPolish, i => i.value === _.last(shareParams.polish));
										polishSliderMobile.noUiSlider.updateOptions({ start: [__polishIndexOfMin, __polishIndexOfMax + 1] });
									this.searchParams.polish = shareParams.polish;
								}
	
								if (symmetrySlider && !_.isEmpty(shareParams.symmetry)) {
									const __symmetryIndexOfMin = _.findIndex(diamondsSymmetry, i => i.value === _.first(shareParams.symmetry)),
										__symmetryIndexOfMax = _.findIndex(diamondsSymmetry, i => i.value === _.last(shareParams.symmetry));
									symmetrySlider.noUiSlider.updateOptions({ start: [__symmetryIndexOfMin, __symmetryIndexOfMax + 1] });
									this.searchParams.symmetry = shareParams.symmetry;
								}
	
								if (symmetrySliderMobile && !_.isEmpty(shareParams.symmetry)) {
									const __symmetryIndexOfMin = _.findIndex(diamondsSymmetry, i => i.value === _.first(shareParams.symmetry)),
										__symmetryIndexOfMax = _.findIndex(diamondsSymmetry, i => i.value === _.last(shareParams.symmetry));
									symmetrySliderMobile.noUiSlider.updateOptions({ start: [__symmetryIndexOfMin, __symmetryIndexOfMax + 1] });
									this.searchParams.symmetry = shareParams.symmetry;
								}
							}

						} catch (error) {
							console.warn('error--------',error);
						}
	

						this.updateSearch(true); //Load the first list of diamonds based on the set parameters

						//Check on link queries such as natural/labgrown...
						if(_pathName.includes('natural') && !_pathName.includes('lab-grown-diamonds') ) this.searchParams.is_labgrown = false;
						if(!_pathName.includes('labgrown') && !_pathName.includes('natural') ) this.searchParams.is_labgrown = true;
						if(_pathName.includes('fancycolor')) this.searchParams.is_fancy = true;
						if(_pathName.includes('idealcut')) this.searchParams.is_idealcut = true;
						if(_pathName.includes('idealplus')) this.searchParams.is_idealplus = true;
						if(_pathName.includes('round-cut')) this.searchParams.selectedShape = "Round";
						if(_pathName.includes('oval-cut')) this.searchParams.selectedShape = "Oval";
						if(_pathName.includes('cushion-cut')) this.searchParams.selectedShape = "Cushion";
						if(_pathName.includes('princess-cut')) this.searchParams.selectedShape = "Princess";
						if(_pathName.includes('pear-cut')) this.searchParams.selectedShape = "Pear";
						if(_pathName.includes('emerald-cut')) this.searchParams.selectedShape = "Emerald";
						if(_pathName.includes('marquise-cut')) this.searchParams.selectedShape = "Marquise";
						if(_pathName.includes('asscher-cut')) this.searchParams.selectedShape = "Asscher";
						if(_pathName.includes('radiant-cut')) this.searchParams.selectedShape = "Radiant";
						if(_pathName.includes('heart-cut')) this.searchParams.selectedShape = "Heart";
						if(_pathName.includes('shield-cut')) this.searchParams.selectedShape = "Shield";
						if(_pathName.includes('rose-cut')) this.searchParams.selectedShape = "Rose";
						if(_pathName.includes('triangular-cut')) this.searchParams.selectedShape = "Triangular";
						if(_pathName.includes('hexagonal-cut')) this.searchParams.selectedShape = "Hexagonal";
						if(_pathName.includes('kite-cut')) this.searchParams.selectedShape = "Kite";
						if(_pathName.includes('tapered-baguette-cut')) this.searchParams.selectedShape = "Tapered Baguette";
						if(_pathName.includes('square-emerald-cut')) this.searchParams.selectedShape = "Square Emerald";
						if(_pathName.includes('briolette-cut')) this.searchParams.selectedShape = "Briolette";
						if(_pathName.includes('half-cut')) this.searchParams.selectedShape = "Half Moon";
						if(_pathName.includes('european-cut')) this.searchParams.selectedShape = "European Cut";

					});
					this.loadSomeReviews();
				}, 10);

				const wishlist = localStorage.getItem(window.WishlistStorageKey);
				let wishlistArray = [];
				if(wishlist) {
					wishlistArray = JSON.parse(wishlist);
				}

				this.wishlist = wishlistArray;

			},
			methods: {
				showMobileFilter: function(){
					this.isVisibleMobileFilter = !this.isVisibleMobileFilter;
					window.scrollTo(0,0);
				},
				caretPosition: function() {

					const list = [ 5.1, 6.4, 7.4, 8.1, 8.7, 9.1, 9.7, 10.2, 10.5, 17.9, ],
					goal = parseFloat(_.head(this.selectedSingleDiamond.dimensions.split('-'))),
					common = list.reduce( (prev, current) => Math.abs(goal - current) < Math.abs(goal - prev) ? current : prev),
					listIndex = list.indexOf(common) + 1,
					positionPercent = ((listIndex / list.length) * 100),
					positionOffset = (100 - (100 / (common / goal))) / 2;

					return Math.max(5 , Math.min(105, positionPercent - positionOffset));
				},
				maxPriceChange: function($event){
					try {
						const maxPrice = Number($event.target.value.replaceAll('$','').replaceAll(',',''));
						if(this.searchParams.price.max === maxPrice) return
						priceSlider.noUiSlider.set([parseFloat(this.searchParams.price.min),parseFloat(maxPrice)]);
                        this.searchParams.price.max = parseFloat(maxPrice);
                        this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minPriceChange: function($event){
					try {
						const minPrice = Number($event.target.value.replaceAll('$','').replaceAll(',',''));
						if(this.searchParams.price.min === minPrice) return
						priceSlider.noUiSlider.set([parseFloat(minPrice), parseFloat(this.searchParams.price.max)]);
                        this.searchParams.price.min = parseFloat(minPrice);
                        this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				maxCaratChange: function($event){
					try {
						const maxCarat = Number($event.target.value.replaceAll('ct','').replaceAll(',',''));
						if(this.searchParams.carat.max === maxCarat) return
						caratSlider.noUiSlider.set([parseFloat(this.searchParams.carat.min),parseFloat(maxCarat)]);
                        this.searchParams.carat.max = parseFloat(maxCarat);
                        this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minCaratChange: function($event){
					try {
						const minCarat = Number($event.target.value.replaceAll('ct','').replaceAll(',',''));
						if(this.searchParams.carat.min === minCarat) return
						caratSlider.noUiSlider.set([parseFloat(minCarat), parseFloat(this.searchParams.carat.max)]);
                        this.searchParams.carat.min = parseFloat(minCarat);
                        this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				maxTableChange: function($event){
					try {
						const maxTable = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.table.max === maxTable) return
						tableSlider.noUiSlider.set([parseFloat(this.searchParams.table.min),parseFloat(maxTable)]);
						tableSliderMobile.noUiSlider.set([parseFloat(this.searchParams.table.min),parseFloat(maxTable)]);
						this.searchParams.table.max = parseFloat(maxTable);
						this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minTableChange: function($event){
					try {
						const minTable = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.table.min === minTable) return
						tableSlider.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
						tableSliderMobile.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
						this.searchParams.table.min = parseFloat(minTable);
						this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				maxRosiChange: function($event){
					try {
						const maxRosi = Number($event.target.value);
						console.log(maxRosi)
						// if(this.searchParams.table.max === maxTable) return
						// tableSlider.noUiSlider.set([parseFloat(this.searchParams.table.min),parseFloat(maxTable)]);
						// tableSliderMobile.noUiSlider.set([parseFloat(this.searchParams.table.min),parseFloat(maxTable)]);
						// this.searchParams.table.max = parseFloat(maxTable);
						// this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minRosiChange: function($event){
					try {
						const minRosi = Number($event.target.value);
						console.log(minRosi)
						// if(this.searchParams.table.min === minTable) return
						// tableSlider.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
						// tableSliderMobile.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
						// this.searchParams.table.min = parseFloat(minTable);
						// this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				maxDepthChange: function($event){
					try {
						const maxDepth = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.depth.max === maxDepth) return
						depthSlider.noUiSlider.set([parseFloat(this.searchParams.depth.min),parseFloat(maxDepth)]);
						depthSliderMobile.noUiSlider.set([parseFloat(this.searchParams.depth.min),parseFloat(maxDepth)]);
						this.searchParams.depth.max = parseFloat(maxDepth);
						this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minDepthChange: function($event){
					try {
						const minDepth = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.depth.min === minDepth) return
						depthSlider.noUiSlider.set([parseFloat(minDepth), parseFloat(this.searchParams.depth.max)]);
						depthSliderMobile.noUiSlider.set([parseFloat(minDepth), parseFloat(this.searchParams.depth.max)]);
                        this.searchParams.depth.min = parseFloat(minDepth);
                        this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				minRatioChange: function($event){
					try {
						const minRatio = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.ratio.min === minRatio) return
						ratioSlider.noUiSlider.set([parseFloat(minRatio), parseFloat(this.searchParams.ratio.max)]);
						ratioSliderMobile.noUiSlider.set([parseFloat(minRatio), parseFloat(this.searchParams.ratio.max)]);
						this.searchParams.ratio.min = parseFloat(minRatio);
						this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				maxRatioChange: function($event){
					try {
						const maxRatio = Number($event.target.value.replaceAll('%','').replaceAll(',',''));
						if(this.searchParams.ratio.max === maxRatio) return
						ratioSlider.noUiSlider.set([parseFloat(this.searchParams.ratio.min),parseFloat(maxRatio)]);
						ratioSliderMobile.noUiSlider.set([parseFloat(this.searchParams.ratio.min),parseFloat(maxRatio)]);
						this.searchParams.ratio.max = parseFloat(maxRatio);
						this.updateSearch(!0)
					} catch (error) {
						console.log(error)
					}
				},
				quickviewTrigger: _.debounce(function($event) {
					if(this.quickviewProperties.visible) return false;
					this.quickviewProperties.visible = !0;
					this.quickviewProperties.top = $event.target.getBoundingClientRect().top;
					this.quickviewProperties.left = $event.target.getBoundingClientRect().right;
					setTimeout(() => {
						const boundingClientRect = this.$refs.quickViewComponent.$refs.quickViewWrapperRef.getBoundingClientRect();
						const topExclude = Math.max(0, (boundingClientRect.y + boundingClientRect.height) - window.innerHeight);
						this.quickviewProperties.top = ((this.quickviewProperties.top - topExclude) - 15);
					}, 10);

				}, 500),
				quickviewTriggerOut: _.debounce(function($event) {
					this.quickviewProperties.visible = 0;
				}, 500),
				toggleAdvancedFilterWidget(widgetId) {
					if(this.advancedFilterActiveWidgets.includes(widgetId)) {
						return this.advancedFilterActiveWidgets = this.advancedFilterActiveWidgets.filter(i => i != widgetId);
					}
					return this.advancedFilterActiveWidgets.push(widgetId);
				},
				updateLabCheckbox($event) {

					return setTimeout(() => {
						//If both checked then send empty.
						if(this.$refs.advancedFilterGiaInputDesktop.checked && this.$refs.advancedFilterIgiInputDesktop.checked) {
							this.searchParams.selectedLaboratory = null;
							return this.updateSearch(true);
						}

						if(this.$refs.advancedFilterGiaInputDesktop.checked) {
							this.searchParams.selectedLaboratory = 'gia';
						}

						if(this.$refs.advancedFilterIgiInputDesktop.checked) {
							this.searchParams.selectedLaboratory = 'igi';
						}

						//if none is selected 
						if(!this.$refs.advancedFilterGiaInputDesktop.checked && !this.$refs.advancedFilterIgiInputDesktop.checked) {
							this.searchParams.selectedLaboratory = null;
						}

						return this.updateSearch(true);
					}, 100)



					// //if both are checked then searchParams.selectedLaboratory must be empty otherwise put the value but only if one is checked
					// if(this.$refs.advancedFilterGiaInputDesktop.checked && this.$refs.advancedFilterIgiInputDesktop.checked) {
					// 	this.searchParams.selectedLaboratory = '';
					// 	return this.updateSearch(true);
					// } else {
					// 	if(this.$refs.advancedFilterGiaInputDesktop.checked) {
					// 		this.searchParams.selectedLaboratory = 'gia';
					// 	}
					// 	if(this.$refs.advancedFilterIgiInputDesktop.checked) {
					// 		this.searchParams.selectedLaboratory = 'igi';
					// 	}
					// 	if(!this.$refs.advancedFilterGiaInputDesktop.checked && !this.$refs.advancedFilterIgiInputDesktop.checked) {
					// 		this.searchParams.selectedLaboratory = null;
					// 	}
					// 	return this.updateSearch(true);
					// }

                },
				updateLabCheckboxMobile($event) {

					//if both are checked then searchParams.selectedLaboratory must be empty otherwise put the value but only if one is checked
					if(this.$refs.advancedFilterGiaInputMobile.checked && this.$refs.advancedFilterIgiInputMobile.checked) {
						this.searchParams.selectedLaboratory = '';
						return this.updateSearch(true);
					} else {
						if(this.$refs.advancedFilterGiaInputMobile.checked) {
							this.searchParams.selectedLaboratory = 'gia';
						}
						if(this.$refs.advancedFilterIgiInputMobile.checked) {
							this.searchParams.selectedLaboratory = 'igi';
						}
						if(!this.$refs.advancedFilterGiaInputMobile.checked && !this.$refs.advancedFilterIgiInputMobile.checked) {
							this.searchParams.selectedLaboratory = '';
						}
						return this.updateSearch(true);
					}

                },
				saveSearchToLocal(data) {
					const saveData = {...data}
					delete saveData.symmetry
					return localStorage.setItem(this.storageKeyName, JSON.stringify(saveData));
				},
				getSearchFromLocal() {
					let _storage = localStorage.getItem(this.storageKeyName);
					if(_.isEmpty(_storage)) _storage;

					return JSON.parse(_storage);
				},
				updateSearch: _.debounce(function (resetList = false) {

					try {

						this.ready = false;
						const parameters = this.searchParams;

						if(this.firstload) this.searchParams.offset = this.searchParams.offset + 50;

						if(resetList) {
							this.searchParams.offset = 0;
						}

						const query = window.diamondQueryTemplate
						let variables = {
							pageSize: 50,
							currentPage: (this.searchParams.offset / 50) + 1,
							filter: {
								shape: this.searchParams.selectedShape,
								diamondcolor: this.searchParams.colors,
								price_to: (parseFloat(this.searchParams.price.max) / parseFloat(Shopify.currency.rate)), //Convert it back to USD before submitting.
								price_from: (parseFloat(this.searchParams.price.min) / parseFloat(Shopify.currency.rate)), //Convert it back to USD before submitting.
								carat_to:this.searchParams.carat.max,
								carat_from:this.searchParams.carat.min,
								ratio_to: parseFloat(this.searchParams.ratio.max),
								ratio_from: parseFloat(this.searchParams.ratio.min),
								tabl_to:parseInt(this.searchParams.table.max),
								tabl_from:parseInt(this.searchParams.table.min),
								rosi_score_to:parseInt(this.searchParams.rosi.max),
								rosi_score_from:parseInt(this.searchParams.rosi.min),
								depth_to:parseInt(this.searchParams.depth.max),
								depth_from:parseInt(this.searchParams.depth.min),
								cut: this.searchParams.cut.map(item => Object.fromEntries(window.diamondsCut.map(m => [m.value, m.shortcode]))[item] || item), //Need change e.g Excellent should become EX
								clarity: this.searchParams.clarity, //Need change e.g Excellent should become EX
								polish: this.searchParams.polish.map(item => Object.fromEntries(window.diamondsPolish.map(m => [m.value, m.shortcode]))[item] || item), //Need change e.g Excellent should become EX
								symmetry: this.searchParams.symmetry.map(item => Object.fromEntries(window.diamondsSymmetry.map(m => [m.value, m.shortcode]))[item] || item), //Need change e.g Excellent should become EX

								is_labgrown: Number(this.searchParams.is_labgrown),
								is_fancy: Number(this.searchParams.is_fancy),
							}
						}

						if(this.searchParams.is_idealcut) {
							variables.filter.is_idealcut = Number(this.searchParams.is_idealcut)
						}
						if(this.searchParams.is_idealplus) {
							variables.filter.is_superidealcut = Number(this.searchParams.is_idealplus)
						}



						if(this.searchParams.selectedLaboratory) 
							variables.filter.lab = String(this.searchParams.selectedLaboratory).toUpperCase();

						if(this.searchParams.is_fancy) {
							delete variables.filter.diamondcolor
							variables.filter.fancycolor = this.searchParams.fancycolor
							variables.filter.fluorescence = this.searchParams.fluorescence.map(item => item.shortcode) //Need change e.g Strong should become S
							variables.filter.fancy_intensity = this.searchParams.fancyintensity.map(item => item.shortcode) //Need change e.g Strong should become S
						}

						if(!_.isEmpty(this.searchParams.skusearch)){
							variables.filter = {}
							variables.filter.sku = this.searchParams.skusearch;
						}

						if(this.searchParams.orderby && this.searchParams.order) {
							variables.sort = {
								[this.searchParams.orderby]: String(this.searchParams.order).toUpperCase()
							}
						} else {
							variables.sort = {
								price: 'ASC'
							}
						}

						if(this.searchParams.selectedShape !== 'Round') //Other shapes don't support cuts.
							variables.filter.cut = [];

						fetch(`${window.apiBaseUrl}/graphql`, {
							method: 'POST',
							mode: 'cors',
							cache: 'no-cache',
							credentials: 'same-origin',
							headers: {
								'Content-Type': 'application/json',
							},
							body:JSON.stringify({
								query: query,
								variables: variables
							})
						}).then(response => response.json())
						.then(response => {
							let rows = response?.data?.diamondInventorySearch?.items
							rows = rows.map( diamond => {
								diamond.loadingMedia = false; // boolean type
								diamond.media = {}; //Object of data
								if(diamond.diamond_video) {
									const match = diamond.diamond_video.match(/^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/);
									if (match[0]) diamond.media.video = match[0];
								}
								if(!diamond.diamond_image) {
									diamond.media.picture = `https://hermanos.rockher.com/static/frontend/Rockher/Winter/en_US/Rockher_Diamondsearch/images/diamondsearch/shapes/${diamond.shape.toLowerCase()}.jpg`
								} else {
									diamond.media.picture = diamond.diamond_image
								}
								if(!diamond.fprice) diamond.fprice = diamond.price / 0.7;
								if(!diamond.entity_id) diamond.entity_id = diamond.sku;
								return diamond;
							})

							if(resetList) {
								this.query.diamonds = rows;
							} else {
								this.query.diamonds = [...this.query.diamonds, ...rows];
							}


							this.query.count = response?.data?.diamondInventorySearch?.total_count;
							this.query.collectionTotal = response?.data?.diamondInventorySearch?.total_count_all;
							this.firstload = true;
							this.ready = true;
							this.selectedDiamond = null;
							if (!_.isUndefined(this.query.diamonds) && !_.isEmpty(this.query.diamonds)) {
								this.selectDiamond(_.head(this.query.diamonds));
							}

						})
						.catch(error => {
							console.warn(error)
							this.ready = true;
						})




					} catch (error) {
						console.warn(error);
					}
				}, 400),
				proxyLoadCertificate( diamondId ) {
					this.openDropBox('certificateInfoSingle', null)
					this.loading_certificate = true;
					//Fetch from the server.
					const request = fetch(`${window.apiBaseUrl}/diamondsearch/ajax/getcertimg`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'x-requested-with': 'XMLHttpRequest',
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
						},
						body: `diamondId=${diamondId}`,
					}).then(res => res.json())
					.then(response => {
						this.loading_certificate = false;
						const data = JSON.parse(response);
						this.selectedDiamond.certificate_object = data;
						if(!_.isEmpty(this.selectedSingleDiamond)) {
							this.selectedSingleDiamond.certificate_object = data;
						}
					})
					.catch(err => {
						console.warn(err);
					});
				},
				switchDiamondLoadedType() {
                    if(typeof this.searchParams.is_labgrown === 'string' ) this.searchParams.is_labgrown = this.searchParams.is_labgrown === 'true' ? true : false;
					//If false means the search will switch to labgown
					this.updateSearch(true);
				},
				updateShape(item) {
					this.searchParams.selectedShape = this.searchParams.selectedShape !== item ? item : window.diamondsShapes.map(shape => shape.value).join(',');
					//Make sure if the super ideal cut enabled but the user selects other than rounded diamonds you should disable the super ideal cut.
					if(item !== 'Round') this.searchParams.is_idealplus = false;
					this.updateSearch(true);
				},
				updateFancycolor(item) {
					this.searchParams.fancycolor = item;
					this.updateSearch(true);
				},
				dropHintRequestMessageChange() {
					console.log(this.dropHintRequestMessageChangeModel)
				},
				closeDropBox(item) {
					this.popboxes[item] = false;
					this.dropHintMessageText = '';
				},
				openDropBox(item, $event) {
					if($event) $event.preventDefault();
					this.popboxes[item] = true
				},
				wishlistAdd() {

					const id = this.selectedSingleDiamond.sku
					const wishlist = localStorage.getItem(window.WishlistStorageKey);
					let wishlistArray = [];
					if(wishlist) {
						wishlistArray = JSON.parse(wishlist);
					}

					const product = {
						id: this.selectedSingleDiamond.sku,
						sku: this.selectedSingleDiamond.sku,
						title: `${parseFloat(this.selectedSingleDiamond.carat).toFixed(2)} Carat ${this.selectedSingleDiamond.shape} ${this.selectedSingleDiamond.is_labgrown ? 'Lab Grown' : 'Natural'} Diamond`,
						price: this.selectedSingleDiamond.price,
						fprice: this.selectedSingleDiamond.fprice,
						featured_image: this.selectedSingleDiamond.media.picture,
						handle: this.selectedSingleDiamond.handle,
						inbuilder: false,
						type: 'diamond',
						is_labgrown: this.selectedSingleDiamond.is_labgrown,
					}

					if(_.isEmpty(wishlistArray.filter( item => item.id == product.id))) {
						wishlistArray.push(product);
					}else {
						wishlistArray = wishlistArray.filter( item => item.id !== product.id);
					}

					this.wishlist = wishlistArray;

					localStorage.setItem(window.WishlistStorageKey, JSON.stringify(wishlistArray));
					return window.dispatchEvent(new CustomEvent('wishlistChanged'));

				},
				shareStone() {
					if (this.copied) return false;
					let textElement = document.createElement('textarea');
					textElement.value = window.location.href;
					document.body.appendChild(textElement);
					textElement.select();
					document.execCommand('copy');
					document.body.removeChild(textElement);
					this.copied = true;
					return setTimeout(() => {
						this.copied = false
					}, 500);
				},
				async addToBag(item) {

					let diamond = item;
					if (!diamond) diamond = this.selectedDiamond;
					if (!diamond.sku || diamond.price <= 0) return;
					this.addtobagloading = true

					//Check if the diamond already exist in the bag.
					const cardItems = await fetch(`/cart.js`, { method: 'GET', }) .then( response => response.json())
					if(!_.isEmpty(cardItems.items.filter( item => item?.properties?.SKU === diamond.sku))) {
						this.addtobagloading = false;
						return window.alert('This diamond is already in your cart.');
					}
					
					fetch(`https://rockher-flow.evosem.com/shopify/setup/creation`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'x-requested-with': 'XMLHttpRequest',
							'Content-Type': 'application/json',
						},
					body:JSON.stringify({
						stock_number: diamond.sku,
					})
					}).then(res => res.json())
					.then(res => {
						if (res.status) {
							try {
								const variantId = res?.shopifyCreate?.data?.productSet?.product?.variants?.edges[0].node?.legacyResourceId

								return setTimeout(() => {
									return fetch(`${window.Shopify.routes.root}cart/add.js`, {
										method: 'POST',
										headers: {
											'Content-Type': 'application/json'
										},
										body: JSON.stringify({
											items: [{
												id: variantId,
												quantity: 1,
												properties: {
													SKU: diamond.sku ? diamond.sku : 'N/A',
													Cut: diamond.cut ? diamond.cut : this.getSymmetryName(diamond.symmetry),
													Color: diamond.diamondcolor ? diamond.diamondcolor : 'N/A',
													Clarity: diamond.clarity ? diamond.clarity : 'N/A',
													Lab: diamond.lab ? diamond.lab : 'N/A',
													Certificate: diamond.gia_report_num ? diamond.gia_report_num : 'N/A',
												}
											}]
										})
									}).then(res => res.json())
									.then(res => {
										this.addtobagloading = false;
										window.location = `/cart`;
										const k_item = {
											Name: `${parseFloat(diamond.carat).toFixed(2)} Carat ${diamond.shape} ${diamond.is_labgrown ? 'Lab Grown' : 'Natural'} Diamond`,
											ProductID: diamond.sku,
											Categories: [`${diamond.is_labgrown ? 'Lab Grown' : 'Natural'} Diamond`],
											ImageURL: diamond.media.picture,
											URL: `https://${Shopify.shop}/apps/diamondsearch/`+`${diamond.carat}-carat-${diamond.shape}-diamond-${diamond.sku}`.toLocaleLowerCase().replaceAll('.','-'),
											Brand: "Rockher",
											Price: __formatPrice(diamond.price),
											CompareAtPrice: diamond.is_labgrown ? __formatPrice(diamond.fprice) : '$0.00',
											$use_ip: true,
											$is_session_activity: true
										}
										_learnq.push(['track', 'Added to Cart', k_item])
									}).catch(error => {
										//Dialog info box.
										this.addtobagloading = false;
										console.warn(error);
									})
								},1000)
							} catch (error) {
								console.warn(error)
							}
						}
					}).catch(error => {
						//Dialog info box.
						console.warn(error);
					});
				},
				async addToRing(item) {

					try {

						let diamond = item;
						if (!diamond) diamond = this.selectedDiamond;
						if (!diamond.sku || diamond.price <= 0) return;
						this.addtobagloading = true;

						const query = window.diamondQueryTemplate 
						const variables = {
							filter: {
								sku: diamond.sku
							}
						}


						let singleDiamond = await fetch(`${window.apiBaseUrl}/graphql`, {
							method: 'POST',
							mode: 'cors',
							cache: 'no-cache',
							credentials: 'same-origin',
							headers: {
								'Content-Type': 'application/json',
							},
							body:JSON.stringify({
								query: query,
								variables: variables
							})
						}).then(response => response.json())

						if(!singleDiamond) {
							window.alert('Unable to find the requested diamond please try a different one.')
							return this.addtobagloading = false; // Skip function.
						}

						try {
							let shop_ring_settings = localStorage.getItem(MainRingBuilderStorageKey);
	
							const diamondRequested = diamond
							const { shape, carat, sku } = diamondRequested;
							const customUrl = `${carat}-carat-${shape}-diamond-${sku}`.toLocaleLowerCase().replaceAll('.','-');
							diamondRequested.customUrl = customUrl;
							diamondRequested.priceNumber = diamondRequested.price;
	
							shop_ring_settings = !_.isEmpty(shop_ring_settings) ? JSON.parse(shop_ring_settings) : {};
							shop_ring_settings.diamond = diamondRequested;
	
							//Save to localstorage								
							const setItemObjection = localStorage.setItem;
							localStorage.setItem = function(key, value) {
								const event = new Event('ringbuilderstoragechange');
								event.value = value; // Optional..
								event.key = key; // Optional..
								document.dispatchEvent(event);
								setItemObjection.apply(this, arguments);
							};
	
							localStorage.setItem(MainRingBuilderStorageKey, JSON.stringify(shop_ring_settings));
							document.dispatchEvent(new CustomEvent('ringbuilderstoragechange', {
								bubbles: true,
								cancelable: true,
							}));
	
							this.addtobagloading = false;
							if(_.isEmpty(shop_ring_settings.ring)) return window.location = `/collections/build-an-engagement-ring/?filter.p.m.global.center_shape=${_.head(shapesTypes.filter( s => s.label === shape)).shortcode}`;
							return window.location = '/pages/ringbuilder/';
	


						} catch( error ) {
							console.log(error)
							window.alert('Something went wrong please try again later.')
							return this.addtobagloading = false;
						}

					} catch( error ) {
						window.alert('Something went wrong please try again later.')
						return this.addtobagloading = false;
					}

				},
				async loadSingleDiamond() {
					try {

						const _pathName = window.location.pathname.split('-');
						const _pathNameIndex = _.findIndex(window.location.pathname.split('-'), (i) => i === 'diamond');
						if (_pathNameIndex && (_pathNameIndex !== -1)) {
							const __stockNumber = _pathName.slice((_pathNameIndex + 1),_pathName.length).join('-');

							this.loadingSingleDiamondPath = true;

							try {

								const query = window.diamondQueryTemplate 
								const variables = {
									filter: {
										sku: __stockNumber
									}
								}

								let singleDiamond = await fetch(`${window.apiBaseUrl}/graphql`, {
									method: 'POST',
									mode: 'cors',
									cache: 'no-cache',
									credentials: 'same-origin',
									headers: {
										'Content-Type': 'application/json',
									},
									body:JSON.stringify({
										query: query,
										variables: variables
									})
								}).then(response => response.json())

								singleDiamond = singleDiamond?.data?.diamondInventorySearch?.items.map( diamond => {
									diamond.loadingMedia = false; // boolean type
									diamond.media = {}; //Object of data
									if(diamond.diamond_video) {
										const match = diamond.diamond_video.match(/^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/);
										if (match[0]) diamond.media.video = match[0];
									}
									if(!diamond.image) {
										diamond.media.picture = `https://hermanos.rockher.com/static/frontend/Rockher/Winter/en_US/Rockher_Diamondsearch/images/diamondsearch/shapes/${diamond.shape.toLowerCase()}.jpg`
									} else {
										diamond.media.picture = diamond.image
									}
									if(!diamond.fprice) diamond.fprice = diamond.price / 0.7;
									if(!diamond.entity_id) diamond.entity_id = diamond.sku;
									return diamond;
								})

								
								
								if (!_.isEmpty(singleDiamond)) {
									this.loadingSingleDiamondPath = false;
									return this.openDiamondSingleView(_.head(singleDiamond), false);								
								}
								
								const outOfStockDiamond = await fetch(`${window.apiBaseUrl}/rockhervariants/ajax/diamondlog`,{
									method: 'POST',
									mode: 'cors',
									cache: 'no-cache',
									credentials: 'same-origin',
									headers: {
										'x-requested-with': 'XMLHttpRequest',
										'Content-Type': 'application/json',
									},
									body: JSON.stringify({
										sku: __stockNumber,
									}),
								}).then(res => res.json())
								
								if(outOfStockDiamond.status) {
									this.loadingSingleDiamondPath = false;
									// outOfStockDiamond._diamond = outOfStockDiamond._diamond ? outOfStockDiamond._diamond : {}
									// outOfStockDiamond._diamond.type = outOfStockDiamond?._diamond?.vendor === 'NIVODALG' ? 'Lab Grown' : 'Natural';

									outOfStockDiamond._diamond = outOfStockDiamond?.product ? outOfStockDiamond?.product : {}
									outOfStockDiamond._diamond.recommendations = outOfStockDiamond?.recommendations?.rows;
									outOfStockDiamond._diamond.missing_juvenile = outOfStockDiamond?.missing_juvenile;
									return this.outOfStockDiamond = outOfStockDiamond._diamond;
								}

								return this.loadingSingleDiamondPath = false;


							} catch ( error ) {
								this.loadingSingleDiamondPath = false;
								console.log(error);
							}

						}

					} catch (error) {
						console.warn(error)
					}
				},
				showDialogSearchMore() {
					this.visibleDialogSearchMore = !this.visibleDialogSearchMore;
				},
				showDialogSearch(item) {
					document.body.classList.add('__evosem_overflow-hidden');
					if (this.visibleDialogSearch === item) {
						return this.closeDialogSearch();
					}
					this.visibleDialogSearch = null;
					return this.visibleDialogSearch = item;
				},
				closeDialogSearch() {
					document.body.classList.remove('__evosem_overflow-hidden');
					return this.visibleDialogSearch = null;
				},
				getCutName(_value) {
					const item = diamondsCut.filter(i => i.shortcode === _value);
					if (!_.isEmpty(item)) return item[0].label;

					return _value;

				},
				getFluorescencesName(_value) {
					const item = diamondsFluorescences.filter(i => i.shortcode === _value);
					if (!_.isEmpty(item)) return item[0].label;

					return _value;

				},
				getIntensityName(_value) {
					const item = diamondsIntensity.filter(i => i.shortcode === _value);
					if (!_.isEmpty(item)) return item[0].label;

					return _value;

				},
				getPolishName(_value) {
					const item = diamondsPolish.filter(i => i.shortcode === _value);
					if (!_.isEmpty(item)) return item[0].label;

					return _value;

				},
				getSymmetryName(_value) {
					const item = diamondsSymmetry.filter(i => i.shortcode === _value);
					if (!_.isEmpty(item)) return item[0].label;

					return _value;

				},
				selectDiamond(item) {
					if(this.selectedDiamond?.entity_id === item?.entity_id) return; //prevent endless state update of the same item.
					this.selectedDiamond = item;
				},
				loadSingleDiamondMedia() {
					if(!this.selectedSingleDiamond?.media?.video) return;
					this.selectedDiamondLoadingMedia = !this.selectedDiamondLoadingMedia;
				},
				async openDiamondSingleView(item, pushToHistory = true, newtab = false) {

					const customUrl = `${item.carat}-carat-${item.shape}-diamond-${item.sku}`.toLocaleLowerCase().replaceAll('.','-');

					if(newtab) {
						window.open(`/apps/diamondsearch/${item.carat}-carat-${item.shape}-diamond-${item.sku}`.replaceAll('.','-').toLocaleLowerCase(), '_blank');
						return;
					}

					item.priceNumber = item.price;
					if(_.isString(item.is_labgrown)) item.is_labgrown = item.is_labgrown === 1; //Convert it to boolean type;
					if (item) this.selectedSingleDiamond = item;

					window.scrollTo({ top: 0 });
					this.singleDiamondView = true;
					this.selectedMediaPreview = 'image';
					this.similarDiamonds = null;
					this.outOfStockDiamond = null;


					//Load similar diamonds based on price and carat range.
					console.log("Load similar diamonds.")

					const query = window.diamondQueryTemplate
					let variables = {
						pageSize: 4,
						filter: {
							shape: item.shape,
							price_to: (parseFloat( (item.price + (item.price * 0.10))/100 ) / parseFloat(Shopify.currency.rate)), //Convert it back to USD before submitting.
							price_from: (parseFloat( (item.price - (item.price * 0.10))/100 ) / parseFloat(Shopify.currency.rate)), //Convert it back to USD before submitting.
							carat_to: parseFloat( (item.carat + (item.carat * 0.10)).toFixed(1) ),
							carat_from: parseFloat( (item.carat - (item.carat * 0.10)).toFixed(1) ),
							is_labgrown: item.is_labgrown,
							is_fancy: this.searchParams.is_fancy,
							is_fancy: item.is_fancy,
							fancycolor: item.fancycolor,

						}
					}

					const recommendations = await fetch(`${window.apiBaseUrl}/graphql`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'Content-Type': 'application/json',
						},
						body:JSON.stringify({
							query: query,
							variables
						})
					}).then(response => response.json())

					if(recommendations?.data?.diamondInventorySearch?.items) {

						let rows = recommendations?.data?.diamondInventorySearch?.items
						rows = rows.map( diamond => {
							diamond.loadingMedia = false; // boolean type
							diamond.media = {}; //Object of data
							if(diamond.diamond_video) {
								const match = diamond.diamond_video.match(/^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/);
								if (match[0]) diamond.media.video = match[0];
							}
							if(!diamond.diamond_image) {
								diamond.media.picture = `https://hermanos.rockher.com/static/frontend/Rockher/Winter/en_US/Rockher_Diamondsearch/images/diamondsearch/shapes/${diamond.shape.toLowerCase()}.jpg`
							} else {
								diamond.media.picture = diamond.diamond_image
							}
							if(!diamond.fprice) diamond.fprice = diamond.price / 0.7;
							if(!diamond.entity_id) diamond.entity_id = diamond.sku;
							return diamond;
						})

						this.$set(this.selectedSingleDiamond, 'recommendations', rows)
					}

					try {

						this.selectedSingleDiamond.handle = customUrl;
						if (pushToHistory) this.$router.push(`${this.pathname}/${customUrl}`)

						const diamondName = `${parseFloat(this.selectedSingleDiamond.carat).toFixed(2)} Carat ${this.selectedSingleDiamond.shape} ${this.selectedSingleDiamond.is_labgrown ? 'Lab Grown' : 'Natural'} Diamond`
						document.title = diamondName

						if(document.querySelector('meta[name="og:title"]')) document.querySelector('meta[name="og:title"]').setAttribute('content', diamondName)
						if(document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').setAttribute('content', diamondName)
						if(document.querySelector('meta[property="og:url"]')) document.querySelector('meta[property="og:url"]').setAttribute('content', `${this.pathname}/${customUrl}`)

						//Event tracker
						const k_item = {
							Name: diamondName,
							ProductID: this.selectedSingleDiamond.sku,
							Categories: [`${this.selectedSingleDiamond.is_labgrown ? 'Lab Grown' : 'Natural'} Diamond`],
							ImageURL: this.selectedSingleDiamond.media.picture,
							URL: `https://${Shopify.shop}/apps/diamondsearch/`+`${this.selectedSingleDiamond.carat}-carat-${this.selectedSingleDiamond.shape}-diamond-${this.selectedSingleDiamond.sku}`.toLocaleLowerCase().replaceAll('.','-'),
							Brand: "Rockher",
							Price: __formatPrice(this.selectedSingleDiamond.price),
							CompareAtPrice: this.selectedSingleDiamond.is_labgrown ? __formatPrice(this.selectedSingleDiamond.fprice) : '$0.00',
						}


						if(_learnq) {
							_learnq.push(['track', 'Viewed Product', k_item])
							_learnq.push(['trackViewedItem', {
								Title: k_item.Name,
								ItemId: k_item.ProductID,
								Categories: k_item.Categories,
								ImageUrl: k_item.ImageURL,
								Url: k_item.URL,
								Metadata: {
									Brand: k_item.Brand,
									Price: k_item.Price,
									CompareAtPrice: k_item.CompareAtPrice
								}
							}])
						}


					} catch (error) {
						console.warn(error)
					}

				},
				closeDiamondSingleView() {
					window.history.pushState(false, false, `${this.pathname}`);
					this.singleDiamondView = false;
					this.selectedSingleDiamond = null;
					this.selectedMediaSinglePreview = 'image';
					this.similarDiamonds = null;
					this.outOfStockDiamond = null;
					this.selectedDiamondLoadingMedia = false
					document.title = 'GIA Certified Diamonds - Shop Natural Diamonds - Bespoke Engagement Rings Since 1967 - RockHer.com'
					if(document.querySelector('meta[name="og:title"]')) document.querySelector('meta[name="og:title"]').setAttribute('content', 'GIA Certified Diamonds - Shop Natural Diamonds - Bespoke Engagement Rings Since 1967 - RockHer.com')
				},
				updateLabCerts(item) {
					if (typeof this.searchParams.lab === 'undefined') this.searchParams.lab = [];
					if (this.searchParams.lab.filter(c => c === item.label).length) {
						this.searchParams.lab = this.searchParams.lab.filter(c => c !== item);
					} else {
						this.searchParams.lab = [...this.searchParams.lab, item];
					}
					this.resetOffset();
					this.updateSearch(true);
				},
				skuSearchInput() {
					this.resetOffset();
					this.updateSearch(true);
				},
				switchMediaPreview(mode) {
					this.selectedMediaPreview = mode;
				},
				switchMediaSinglePreview(mode) {
					this.selectedMediaSinglePreview = mode;
				},
				switchViewMode(mode) {
					this.displayMode = mode;
                    this.updateSearch(true);
				},
				switchViewModeMobile() {
					this.displayMode = this.displayMode === 'list' ? 'grid' : 'list';
					this.updateSearch(true);
				},
				toggleAdvancedFilter() {
					this.advancedOptionsOn = !this.advancedOptionsOn;
				},
				resetOffset() {
					this.searchParams.offset = 0;
				},
				switchOrder(item) {
					if (item === this.searchParams.orderby) this.searchParams.order = this.searchParams.order === 'desc' ? 'asc' : 'desc';
					this.searchParams.orderby = item;
					this.resetOffset();
					return this.updateSearch(true);
				},
				switchOrderSelect($event) {
					try {
						const value = $event.target.value.split(',');
						this.searchParams.orderby = value[0]
						this.searchParams.order = value[1]
						this.resetOffset();
						return this.updateSearch(true);
					} catch( error ){
						console.log(error)
					}
				},
				loadMoreDiamondsScroll(){
					window.addEventListener('scroll', () => {
						if(!this.ready || this.selectedSingleDiamond) return;

						if((this.$refs.diamondSearchResultContainer.clientHeight - 200) <= document.documentElement.scrollTop) {
							this.loadMoreDiamonds();
						}
					});
				},
				loadMoreDiamonds() {
					this.updateSearch(false);
				},
				loadSimilarDiamonds() {
					let { sku, shape, cut, carat, polish, symmetry, price } = this.selectedSingleDiamond;
					const ___shape = window.__shapes.filter(i => i.label === shape);

					if (!_.isEmpty(___shape)) {
						shape = ___shape[0].value;
					} else {
						shape = window.diamondsShapes.map(s => s.value).join(',');
					}

					const request = fetch(`${window.__evosem_ssurl}/diamond-search/query`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							selectedShape: [shape],
							cut: [cut],
							polish: [polish],
							symmetry: [symmetry],
						})
					}).then(res => res.json())
						.then(data => {
							if (!_.isEmpty(data.diamonds)) {

								data.diamonds = data.diamonds.filter(d => d.sku !== this.selectedSingleDiamond.sku);

								if (_.isEmpty(data.diamonds)) return;

								data.diamonds = data.diamonds.map(d => {

									const shape = __shapes.filter(s => s.value === d.shape);
									const polish = __shapes.filter(s => s.value === d.polish);
									const symmetry = __shapes.filter(s => s.value === d.symmetry);
									const cut = __shapes.filter(s => s.value === d.cut);

									if (!_.isUndefined(shape[0]) && !_.isUndefined(shape[0].label)) d.shape = shape[0].label;
									if (!_.isUndefined(polish[0]) && !_.isUndefined(polish[0].label)) d.polish = polish[0].label;
									if (!_.isUndefined(symmetry[0]) && !_.isUndefined(symmetry[0].label)) d.symmetry = symmetry[0].label;
									if (!_.isUndefined(cut[0]) && !_.isUndefined(cut[0].label)) d.cut = cut[0].label;

									return d;
								})

								this.similarDiamonds = _.shuffle(data.diamonds).slice(0, 4);

							}
						}).catch(error => {
							console.warn(error);
						});
				},
				resetSearch() {

					// this.searchParams.selectedShape = window.diamondsShapes.map(s => s.value).join(',');
					this.searchParams.selectedShape = 'Round'; //For now just set it to rounded diamonds.
					if (priceSlider) {
						priceSlider.noUiSlider.set([parseFloat(__price.min), parseFloat(__price.max)]);
					}

					if (caratSlider) {
						caratSlider.noUiSlider.set([parseFloat(__carat.min), parseFloat(__carat.max)]);
					}

					if (ratioSlider) {
						ratioSlider.noUiSlider.set([parseFloat(__ratio.min), parseFloat(__ratio.max)]);
					}

					if (ratioSliderMobile) {
						ratioSliderMobile.noUiSlider.set([parseFloat(__ratio.min), parseFloat(__ratio.max)]);
					}

					if (rosiSlider) {
						rosiSlider.noUiSlider.set([parseFloat(__rosi.min), parseFloat(__rosi.max)]);
					}

					if (tableSlider) {
						tableSlider.noUiSlider.set([parseFloat(__table.min), parseFloat(__table.max)]);
					}

					if (rosiSlider) {
						rosiSlider.noUiSlider.set([parseFloat(__rosi.min), parseFloat(__rosi.max)]);
					}

					if (tableSliderMobile) {
						tableSliderMobile.noUiSlider.set([parseFloat(__table.min), parseFloat(__table.max)]);
					}

					if (depthSlider) {
						depthSlider.noUiSlider.set([parseFloat(window.__depth.min), parseFloat(window.__depth.max)]);
					}

					if (depthSliderMobile) {
						depthSliderMobile.noUiSlider.set([parseFloat(window.__depth.min), parseFloat(window.__depth.max)]);
					}

					if (colorSlider) {
						colorSlider.noUiSlider.set([0, diamondsColours.length]);
					}

					if (fluorescenceSlider) {
						fluorescenceSlider.noUiSlider.set([0, diamondsFluorescences.length]);
					}

					if (fluorescenceSliderMobile) {
						fluorescenceSliderMobile.noUiSlider.set([0, diamondsFluorescences.length]);
					}

					if (intensitySlider) {
						intensitySlider.noUiSlider.set([0, diamondsIntensity.length]);
					}
						
					if (claritySlider) {
						claritySlider.noUiSlider.set([0, diamondsClarity.length]);
					}

					if (cutSlider) {
						cutSlider.noUiSlider.set([0, diamondsCut.length]);
					}

					if (polishSlider) {
						polishSlider.noUiSlider.set([0, diamondsPolish.length]);
					}

					if (polishSliderMobile) {
						polishSliderMobile.noUiSlider.set([0, diamondsPolish.length]);
					}

					if (symmetrySlider) {
						symmetrySlider.noUiSlider.set([0, diamondsPolish.length]);
					}

					if (symmetrySliderMobile) {
						symmetrySliderMobile.noUiSlider.set([0, diamondsPolish.length]);
					}

					this.searchParams.skusearch = null;
					this.searchParams.selectedLaboratory = '';
					this.searchParams.is_labgrown = this.searchParams.is_labgrown;
					this.searchParams.is_fancy = false;
					this.searchParams.is_provenance = false;
					this.searchParams.is_idealcut = false;
					this.searchParams.is_idealplus = false;
					this.searchParams.orderby = '';
					this.searchParams.order = 'desc';
					this.searchParams.offset = 0;


					this.updateSearch(true);
				},
				shareYourSearch() {
					try {

						const searchParams = JSON.stringify(this.searchParams);
						const encoded = btoa(searchParams);


						function fetchData(){
							return fetch(`${window.__evosem_ssurl}/diamond-search/query/share/search`, {
								method: 'POST',
								mode: 'cors',
								cache: 'no-cache',
								credentials: 'same-origin',
								headers: {
									'X-Shopify-Shop': Shopify.shop,
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({
									search: encoded,
								})
							}).then(response => response.json())
							.then(response => {
								if(!response.status) return;
								var link = `${window.location.origin + window.location.pathname}/#params=${response.uniqueId}`.replace('//#', '#');
								return new Blob([link], { type: 'text/plain' });
							})
						}
						
						var clipboardItem = new ClipboardItem({ 'text/plain': fetchData() });
						navigator.clipboard.write([clipboardItem])
						.then(function () { 
							console.log('copied')
						})
						.catch(function (error) { console.log(error); });

						this.linkCopied = true;
						setTimeout(() => {
							this.linkCopied = false;
						}, 1000)

					} catch (error) {
						console.warn(error);
					}
				},
				getShareParams: async function () {

					try {

						if (!_.isUndefined(window.location.hash.split('#params=')[1])) {
							const shareID = window.location.hash.split('#params=')[1];
							const request = await fetch(`${window.__evosem_ssurl}/diamond-search/query/share/search/load`, {
								method: 'POST',
								mode: 'cors',
								cache: 'no-cache',
								credentials: 'same-origin',
								headers: {
									'X-Shopify-Shop': Shopify.shop,
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({
									shareID: shareID
								})
							}).then(res => res.json())
								.then(res => {
									if (res.status) {
										let sharedParam = res.sharedParam;
										sharedParam = JSON.parse(atob(sharedParam));
										return sharedParam;
									}

									return false;
								})
								.catch(error => {
									console.warn(error);
									return false;
								});

							return request;

						}

						return false;

					} catch (error) {
						return false;
					}
				},
				printDiamond() {
					var prtContent = document.getElementById("_evosem-print-version");
					var WinPrint = window.open('', '', 'toolbar=0,scrollbars=0,status=0');
					WinPrint.document.write(prtContent.innerHTML);
					WinPrint.document.close();
					WinPrint.focus();
					WinPrint.print();
				},
				submitDropHint: async function ($event) {

					$event.preventDefault();
					const { dropHintEmail1, dropHintEmail2, dropHintFullName, dropHintEmail3, dropHintMessage } = this.$refs;
					let errors = [];

					if (this.sendingDropHint) return;

					if (_.isEmpty(dropHintEmail1.value)) errors.push("Friend's Email Address is required");
					if (_.isEmpty(dropHintEmail3.value)) errors.push("Your Email Address is required");
					if (_.isEmpty(dropHintMessage.value)) errors.push("Message is required");
					if (!_.isEmpty(errors)) return console.warn(errors);

					this.sendingDropHint = true;
					const request = fetch(`https://rockher-flow.evosem.com/shopify/drop-hint`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							name: dropHintFullName.value,
							email: dropHintEmail1.value,
							email1: dropHintEmail2.value,
							email2: dropHintEmail3.value,
							message: dropHintMessage.value,
							diamond: this.selectedSingleDiamond.sku
						})
					}).then(res => res.json())
					.then(res => {
						this.sendingDropHint = false;
						this.closeDropBox('drophint');
					}).catch(error => {
						this.sendingDropHint = false;
						console.warn(error);
					});
				},
				submitPriceMatch: async function ($event) {

					$event.preventDefault();
					const { priceMatchFirstName, priceMatchLastName, priceMatchEmail, priceMatchPhone, priceMatchCompetitorLink, priceMatchCompetitor, priceMatchAmount } = this.$refs;
					let errors = [];

					if (this.sendingPriceMatch) return;

					if (_.isEmpty(priceMatchFirstName.value)) errors.push("First name is required");
					if (_.isEmpty(priceMatchLastName.value)) errors.push("Last name  is required");
					if (_.isEmpty(priceMatchEmail.value)) errors.push("Email address is required");
					if (_.isEmpty(priceMatchPhone.value)) errors.push("Phone number is required");
					if (_.isEmpty(priceMatchCompetitorLink.value)) errors.push("Competitor link is required");
					if (_.isEmpty(priceMatchCompetitor.value)) errors.push("Competitor name is required");
					if (_.isEmpty(priceMatchAmount.value)) errors.push("Price offer is required");

					this.sendingPriceMatch = true;

					fetch(`https://rockher-flow.evosem.com/shopify/price-match`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							firstName: priceMatchFirstName.value,
							lastName: priceMatchLastName.value,
							email: priceMatchEmail.value,
							phone: priceMatchPhone.value,
							competitor_link: priceMatchCompetitorLink.value,
							competitor: priceMatchCompetitor.value,
							amount: priceMatchAmount.value,
							diamond: this.selectedSingleDiamond.sku
						})
					}).then(res => res.json())
					.then(res => {
						this.sendingPriceMatch = false;
						this.closeDropBox('pricematch');
					}).catch(error => {
						this.sendingPriceMatch = false;
						console.warn(error);
					});
				},
				submitMakeOffer: async function ($event) {

					$event.preventDefault();
					const { makeOfferFirstName, makeOfferLastName, makeOfferEmail, makeOfferPhone, makeOfferAmount, makeOfferAmountSignup } = this.$refs;
					let errors = [];

					if (this.sendingPriceMatch) return;

					if (_.isEmpty(makeOfferFirstName.value)) errors.push("First name is required");
					if (_.isEmpty(makeOfferLastName.value)) errors.push("Last name  is required");
					if (_.isEmpty(makeOfferEmail.value)) errors.push("Email address is required");
					if (_.isEmpty(makeOfferPhone.value)) errors.push("Phone number is required");
					if (_.isEmpty(makeOfferAmount.value)) errors.push("Competitor link is required");

					this.sendingMakeOffer = true;

					fetch(`https://rockher-flow.evosem.com/shopify/make-offer`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							firstName: makeOfferFirstName.value,
							lastName: makeOfferLastName.value,
							email: makeOfferEmail.value,
							phone: makeOfferPhone.value,
							amount: makeOfferAmount.value,
							diamond: this.selectedSingleDiamond.sku,
							signup: makeOfferAmountSignup.checked,
						})
					}).then(res => res.json())
					.then(res => {
						this.sendingMakeOffer = false;
						this.closeDropBox('makeoffer');
					}).catch(error => {
						this.sendingMakeOffer = false;
						console.warn(error);
					});
				},
				submitEmailFriend: async function ($event) {
					$event.preventDefault();
					const { friendEmailYourName, friendEmail1, friendEmail2, friendEmailMessage } = this.$refs;
					let errors = [];

					if (this.sendingFriendEmail) return;

					if (_.isEmpty(friendEmailYourName.value)) errors.push("Your Name is required");
					if (_.isEmpty(friendEmail1.value)) errors.push("Your Email Address is required");
					if (_.isEmpty(friendEmail2.value)) errors.push("Your Friend's Email Address is required");
					if (_.isEmpty(friendEmailMessage.value)) errors.push("Message is required");
					if (!_.isEmpty(errors)) return console.warn(errors);

					this.sendingFriendEmail = true;
					const request = fetch(`${window.__evosem_ssurl}/diamond-search/query/emailfriend`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							name: friendEmailYourName.value,
							email: friendEmail1.value,
							email1: friendEmail2.value,
							message: friendEmailMessage.value,
							diamond: this.selectedSingleDiamond.sku
						})
					}).then(res => res.json())
						.then(res => {
							this.sendingFriendEmail = false;
							this.closeDropBox('emailfriend');
						}).catch(error => {
							console.warn(error);
						});

				},
				submitRequestMoreInfo: async function ($event) {
					$event.preventDefault();
					const { friendEmail1, friendEmail2, friendEmailMessage } = this.$refs;
					let errors = [];

				},
				submitScheduleView: async function ($event) {
					$event.preventDefault();
					const { viewingEmail, viewingPhoneNumber, viewingMM, viewingDD, viewingYear, viewingTime, viewingMessage } = this.$refs;

					let errors = [];

					if (this.sendingScheduleRequest) return;

					if (_.isEmpty(viewingEmail.value)) errors.push("Your email address is required");
					if (_.isEmpty(viewingPhoneNumber.value)) errors.push("Your phone number is required");
					if (_.isEmpty(viewingMM.value)) errors.push("Please select a month");
					if (_.isEmpty(viewingDD.value)) errors.push("Please select a day");
					if (_.isEmpty(viewingYear.value)) errors.push("Please select a year");
					if (_.isEmpty(viewingTime.value)) errors.push("Please select time");
					if (_.isEmpty(viewingMessage.value)) errors.push("Message is required");
					if (!_.isEmpty(errors)) return console.warn(errors);

					this.sendingScheduleRequest = true;

					const request = fetch(`${window.__evosem_ssurl}/diamond-search/query/scheduleview`, {
						method: 'POST',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						headers: {
							'X-Shopify-Shop': Shopify.shop,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							email: viewingEmail.value,
							phone: viewingPhoneNumber.value,
							month: viewingMM.value,
							day: viewingDD.value,
							year: viewingYear.value,
							time: viewingTime.value,
							message: viewingMessage.value,
							diamond: this.selectedSingleDiamond.sku
						})
					}).then(res => res.json())
						.then(res => {
							viewingMessageText = null;
							this.sendingScheduleRequest = false;
							this.closeDropBox('scheduleview');
						}).catch(error => {
							console.warn(error);
						});

				},
				loadSomeReviews: async function() {
					try {

						if(!window.loadKlaviyoReviews) return
						const request = await window.loadKlaviyoReviews()

						if(request?.reviews) {
							this.reviewsList = request?.reviews
						}

					} catch ( error ) {
						console.warn(error)
					}
				},
				reviewsDaysDifference(dateString) {
					const givenDate = new Date(dateString);
					const currentDate = new Date();
					
					const timeDiff = currentDate - givenDate; // Difference in milliseconds
					const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
				
					return Math.floor(daysDiff);
				}
			}
		});

		window.searchView = searchView;

		window.parentsUntil = (
			currentElement = null, //HTML element
			target = null //Class name
		) => {
			let _continue = true, parent = currentElement;
			do {

				parent = parent.parentElement;

				if (parent === null) return _continue = false;

				if (parent.classList.contains(target)) {
					_continue = false;
					return parent;
				}

			}
			while (_continue);
		}

		window.initialiseSlider = () => {

			//Initialise price slider.
			const priceSlider = document.getElementById('price-slider');
			if (priceSlider) {
				noUiSlider.create(priceSlider, {
					range: {
						'min': [parseFloat(__price.min)],
						'40%': [10000 * parseFloat(Shopify.currency.rate), 1],
						'70%': [20000 * parseFloat(Shopify.currency.rate), 1],
						'90%': [80000 * parseFloat(Shopify.currency.rate), 1],
						'max': [parseFloat(__price.max)],
					},
					start: [parseFloat(__price.min), parseFloat(__price.max)],
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 0, prefix: currentCurrencySymbol }),
						wNumb({ thousand: ',', decimals: 0, prefix: currentCurrencySymbol })
					],
				});
				//Initialise the search parameters with the values set.
				const __priceSlider = priceSlider.noUiSlider.get(true);
				if (__priceSlider) {
					searchView.searchParams.price = {
						min: __priceSlider[0],
						max: __priceSlider[1]
					}
				}
				priceSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 0, prefix: currentCurrencySymbol });
					const parent = parentsUntil(priceSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-price-slide-from')) {
						parent.querySelector('#display-price-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-price-slide-to')) {
						parent.querySelector('#display-price-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				priceSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.price = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise carat slider.
			const caratSlider = document.getElementById('carat-slider');
			if (caratSlider) {
				noUiSlider.create(caratSlider, {
					range: {
						'min': parseFloat(__carat.min),
						'max': parseFloat(__carat.max)
					},
					start: [parseFloat(__carat.min), parseFloat(__carat.max)],
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 2, suffix: 'ct' }),
						wNumb({ thousand: ',', decimals: 2, suffix: 'ct' })
					],
				});
				//Initialise the search parameters with the values set.
				const __caratSlider = caratSlider.noUiSlider.get(true);
				if (__caratSlider) {
					searchView.searchParams.carat = {
						min: __caratSlider[0],
						max: __caratSlider[1]
					}
				}
				caratSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 2, suffix: 'ct' });
					const parent = parentsUntil(caratSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-carat-slide-from')) {
						parent.querySelector('#display-carat-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-carat-slide-to')) {
						parent.querySelector('#display-carat-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				caratSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.carat = {
						min: parseFloat(values[0]),
						max: parseFloat(values[1])
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise ratio slider.
			const ratioSlider = document.getElementById('ratio-slider');
			if (ratioSlider) {
				noUiSlider.create(ratioSlider, {
					range: {
						'min': parseFloat(__ratio.min),
						'max': parseFloat(__ratio.max)
					},
					start: [parseFloat(0), parseFloat(9)],
					connect: true,
					tooltips: [true, true],
				});
				//Initialise the search parameters with the values set.
				const __ratioSlider = ratioSlider.noUiSlider.get(true);
				if (__ratioSlider) {
					searchView.searchParams.ratio = {
						min: __ratioSlider[0],
						max: __ratioSlider[1]
					}
				}
				ratioSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 2 });
					const parent = parentsUntil(ratioSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-ratio-slide-from')) {
						parent.querySelector('#display-ratio-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-ratio-slide-to')) {
						parent.querySelector('#display-ratio-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				ratioSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.ratio = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise rosi slider.
			const rosiSlider = document.getElementById('rosi-slider');
			if (rosiSlider) {
				noUiSlider.create(rosiSlider, {
					range: {
						'min': parseFloat(0),
						'max': parseFloat(100)
					},
					start: [parseFloat(0), parseFloat(100)],
					step: 1,
					connect: true,
				});
				//Initialise the search parameters with the values set.
				const __rosiSlider = rosiSlider.noUiSlider.get(true);
				if (__rosiSlider) {
					searchView.searchParams.rosi = {
						min: __rosiSlider[0],
						max: __rosiSlider[1]
					}
				}
				rosiSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 0 });
					const parent = parentsUntil(rosiSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-rosi-slide-from')) {
						parent.querySelector('#display-rosi-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-rosi-slide-to')) {
						parent.querySelector('#display-rosi-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				rosiSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.rosi = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise table slider.
			const tableSlider = document.getElementById('table-slider');
			if (tableSlider) {
				noUiSlider.create(tableSlider, {
					range: {
						'min': parseFloat(0),
						'max': parseFloat(100)
					},
					start: [parseFloat(0), parseFloat(100)],
					step: 1,
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 0, suffix: '%' }),
						wNumb({ thousand: ',', decimals: 0, suffix: '%' })
					],
				});
				//Initialise the search parameters with the values set.
				const __tableSlider = tableSlider.noUiSlider.get(true);
				if (__tableSlider) {
					searchView.searchParams.table = {
						min: __tableSlider[0],
						max: __tableSlider[1]
					}
				}
				tableSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 0, suffix: '%' });
					const parent = parentsUntil(tableSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-table-slide-from')) {
						parent.querySelector('#display-table-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-table-slide-to')) {
						parent.querySelector('#display-table-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				tableSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.table = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise depth slider.
			const depthSlider = document.getElementById('depth-slider');
			if (depthSlider) {
				noUiSlider.create(depthSlider, {
					range: {
						'min': parseFloat(window.__depth.min),
						'max': parseFloat(window.__depth.max)
					},
					start: [parseFloat(0), parseFloat(100)],
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 2, suffix: '%' }),
						wNumb({ thousand: ',', decimals: 2, suffix: '%' })
					],
				});
				//Initialise the search parameters with the values set.
				const __depthSlider = depthSlider.noUiSlider.get(true);
				if (__depthSlider) {
					searchView.searchParams.depth = {
						min: __depthSlider[0],
						max: __depthSlider[1]
					}
				}
				depthSlider.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 2, suffix: '%' });
					const parent = parentsUntil(depthSlider, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-depth-slide-from')) {
						parent.querySelector('#display-depth-slide-from').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-depth-slide-to')) {
						parent.querySelector('#display-depth-slide-to').value = formatter.to(parseFloat(values[1]));
					}
				});
				depthSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.depth = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise color slider.
			const colorSlider = document.getElementById('color-slider');
			if (colorSlider) {
				noUiSlider.create(colorSlider, {
					range: {
						'min': 0,
						'max': diamondsColours.length
					},
					start: [0, diamondsColours.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __colorSlider = colorSlider.noUiSlider.get(true);
				if (__colorSlider) searchView.searchParams.colors = diamondsColours.slice(parseInt(__colorSlider[0]), parseInt(__colorSlider[1]));
				const colorSlideLabels = parentsUntil(colorSlider, 'filter-inner').querySelector('.steps-labels');
				if (colorSlideLabels) {
					const colorsList = document.createElement('ul');
					diamondsColours.map(c => {
						const item = document.createElement('li');
                        const text = document.createElement('span');
                        text.classList.add('separation-text');
						text.innerText = c;
                        item.appendChild(text);
						item.style.width = `${(100 / diamondsColours.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						item.appendChild(separation);
						return colorsList.appendChild(item);
					});
					colorSlideLabels.appendChild(colorsList);
				}
				colorSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.colors = diamondsColours.slice(parseInt(values[0]), parseInt(values[1]));
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise fluorescence slider.
			const fluorescenceSlider = document.getElementById('fluorescence-slider');
			if (fluorescenceSlider) {
				noUiSlider.create(fluorescenceSlider, {
					range: {
						'min': 0,
						'max': diamondsFluorescences.length
					},
					start: [0, diamondsFluorescences.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __fluorescenceSlider = fluorescenceSlider.noUiSlider.get(true);
				if (__fluorescenceSlider) searchView.searchParams.fluorescence = diamondsFluorescences.slice(parseInt(__fluorescenceSlider[0]), parseInt(__fluorescenceSlider[1]));
				const __fluorescenceSliderLabels = parentsUntil(fluorescenceSlider, 'filter-inner').querySelector('.steps-labels');
				if (__fluorescenceSliderLabels) {
					const fluorescenceList = document.createElement('ul');
					diamondsFluorescences.map(c => {
						const item = document.createElement('li');
                        const text = document.createElement('span');
                        text.classList.add('separation-text');
						text.innerText = c.label;
                        item.appendChild(text);
						item.style.width = `${(100 / diamondsFluorescences.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						item.appendChild(separation);
						return fluorescenceList.appendChild(item);
					});
					__fluorescenceSliderLabels.appendChild(fluorescenceList);
				}
				fluorescenceSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.fluorescence = diamondsFluorescences.slice(parseInt(values[0]), parseInt(values[1]));
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise mobile fluorescence slider.
			const fluorescenceSliderMobile = document.getElementById('fluorescence-slider-mobile');
			if (fluorescenceSliderMobile) {
				noUiSlider.create(fluorescenceSliderMobile, {
					range: {
						'min': 0,
						'max': diamondsFluorescences.length
					},
					start: [0, diamondsFluorescences.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __fluorescenceSliderMobile = fluorescenceSliderMobile.noUiSlider.get(true);
				if (__fluorescenceSliderMobile) searchView.searchParams.fluorescence = diamondsFluorescences.slice(parseInt(__fluorescenceSliderMobile[0]), parseInt(__fluorescenceSliderMobile[1]));
				const __fluorescenceMobileSliderLabels = parentsUntil(fluorescenceSliderMobile, 'filter-inner').querySelector('.steps-labels');
				if (__fluorescenceMobileSliderLabels) {
					const fluorescenceListMobile = document.createElement('ul');
					diamondsFluorescences.map(c => {
						const item = document.createElement('li');
                        const text = document.createElement('span');
                        text.classList.add('separation-text');
						text.innerText = c.label;
                        item.appendChild(text);
						item.style.width = `${(100 / diamondsFluorescences.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						item.appendChild(separation);
						return fluorescenceListMobile.appendChild(item);
					});
					__fluorescenceMobileSliderLabels.appendChild(fluorescenceListMobile);
				}
				fluorescenceSliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.fluorescence = diamondsFluorescences.slice(parseInt(values[0]), parseInt(values[1]));
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise intensity slider.
			const intensitySlider = document.getElementById('intensity-slider');
			if (intensitySlider) {
				noUiSlider.create(intensitySlider, {
					range: {
						'min': 0,
						'max': diamondsIntensity.length
					},
					start: [0, diamondsIntensity.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __intensitySlider = intensitySlider.noUiSlider.get(true);
				if (__intensitySlider) searchView.searchParams.fancyintensity = diamondsIntensity.slice(parseInt(__intensitySlider[0]), parseInt(__intensitySlider[1]));
				const __intensitySliderLabels = parentsUntil(intensitySlider, 'filter-inner').querySelector('.steps-labels');
				if (__intensitySliderLabels) {
					const intensityList = document.createElement('ul');
					diamondsIntensity.map(c => {
						const item = document.createElement('li');
                        const text = document.createElement('span');
                        text.classList.add('separation-text');
						text.innerText = c.label;
                        item.appendChild(text);
						item.style.width = `${(100 / diamondsIntensity.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						item.appendChild(separation);
						return intensityList.appendChild(item);
					});
					__intensitySliderLabels.appendChild(intensityList);
				}
				intensitySlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.fancyintensity = diamondsIntensity.slice(parseInt(values[0]), parseInt(values[1]));
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise clarity slider.
			const claritySlider = document.getElementById('clarity-slider');
			if (claritySlider) {
				noUiSlider.create(claritySlider, {
					range: {
						'min': 0,
						'max': diamondsClarity.length
					},
					start: [0, diamondsClarity.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __claritySlider = claritySlider.noUiSlider.get(true);
				if (__claritySlider) searchView.searchParams.clarity = diamondsClarity.slice(parseInt(__claritySlider[0]), parseInt(__claritySlider[1]));
				const claritySlideLabels = parentsUntil(claritySlider, 'filter-inner').querySelector('.steps-labels');
				if (claritySlideLabels) {
					const clarityList = document.createElement('ul');
					diamondsClarity.map(c => {
						const item = document.createElement('li');
                        const text = document.createElement('span');
                        text.classList.add('separation-text');
						text.innerText = c;
                        item.appendChild(text);
						item.style.width = `${(100 / diamondsClarity.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');
						item.appendChild(separation);
						return clarityList.appendChild(item);
					});
					claritySlideLabels.appendChild(clarityList);
				}
				claritySlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.clarity = diamondsClarity.slice(parseInt(values[0]), parseInt(values[1]));
					searchView.resetOffset();
					searchView.updateSearch(true);
                });
			}

			//Initialise cut slider.
			const cutSlider = document.getElementById('cut-slider');
			if (cutSlider) {
				noUiSlider.create(cutSlider, {
					range: {
						'min': 0,
						'max': diamondsCut.length
					},
					start: [0, diamondsCut.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __cutSlider = cutSlider.noUiSlider.get(true);
				if (__cutSlider) searchView.searchParams.cut = diamondsCut.slice(parseInt(__cutSlider[0]), parseInt(__cutSlider[1])).map(i => i.value);
				const cutSlideLabels = parentsUntil(cutSlider, 'filter-inner').querySelector('.steps-labels');
				if (cutSlideLabels) {
					const cutList = document.createElement('ul');
					diamondsCut.map(c => {
						const item = document.createElement('li');
						item.style.width = `${(100 / diamondsCut.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');

						const label = document.createElement('span');
						label.classList.add('label');
						label.innerText = c.label;

						const value = document.createElement('span');
						value.classList.add('value');
						value.innerText = c.value;

						item.appendChild(label);
						item.appendChild(value);
						item.appendChild(separation);
						return cutList.appendChild(item);
					});
					cutSlideLabels.appendChild(cutList);
				}
				cutSlider.noUiSlider.on('set', (values, handle) => {
					if(searchView.searchParams.selectedShape !== 'Round') {
						searchView.searchParams.symmetry = diamondsCut.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
						if(searchView.searchParams.symmetry.length === 1 && searchView.searchParams.symmetry.includes("IDEAL")) {
							searchView.searchParams.symmetry = ["EXCELLENT"];
						}
					} else if (searchView.searchParams.selectedShape === 'Round' && searchView.searchParams.cut.includes("IDEAL") && searchView.searchParams.is_idealcut) {
						searchView.searchParams.cut = ["EXCELLENT","IDEAL"];
					} else {
						searchView.searchParams.cut = diamondsCut.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise polish slider.
			const polishSlider = document.getElementById('polish-slider');
			if (polishSlider) {
				noUiSlider.create(polishSlider, {
					range: {
						'min': 0,
						'max': diamondsPolish.length
					},
					start: [0, diamondsPolish.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __polishSlider = polishSlider.noUiSlider.get(true);
				if (__polishSlider) searchView.searchParams.polish = diamondsPolish.slice(parseInt(__polishSlider[0]), parseInt(__polishSlider[1])).map(i => i.value);
				const polishSlideLabels = parentsUntil(polishSlider, 'filter-inner').querySelector('.steps-labels');
				if (polishSlideLabels) {
					const polishList = document.createElement('ul');
					diamondsPolish.map(c => {
						const item = document.createElement('li');
						item.style.width = `${(100 / diamondsPolish.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');

						const label = document.createElement('span');
						label.classList.add('label');
						label.innerText = c.label;

						const value = document.createElement('span');
						value.classList.add('value');
						value.innerText = c.value;

						item.appendChild(label);
						item.appendChild(value);
						item.appendChild(separation);
						return polishList.appendChild(item);
					});
					polishSlideLabels.appendChild(polishList);
				}
				polishSlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.polish = diamondsPolish.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise symmetry slider.
			const symmetrySlider = document.getElementById('symmetry-slider');
			if (symmetrySlider) {
				noUiSlider.create(symmetrySlider, {
					range: {
						'min': 0,
						'max': diamondsPolish.length
					},
					start: [0, diamondsPolish.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __symmetrySlider = symmetrySlider.noUiSlider.get(true);
				if (__symmetrySlider) searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(__symmetrySlider[0]), parseInt(__symmetrySlider[1])).map(i => i.value);
				const symmetrySlideLabels = parentsUntil(symmetrySlider, 'filter-inner').querySelector('.steps-labels');
				if (symmetrySlideLabels) {
					const symmetryList = document.createElement('ul');
					diamondsSymmetry.map(c => {
						const item = document.createElement('li');
						item.style.width = `${(100 / diamondsSymmetry.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');

						const label = document.createElement('span');
						label.classList.add('label');
						label.innerText = c.label;

						const value = document.createElement('span');
						value.classList.add('value');
						value.innerText = c.value;

						item.appendChild(label);
						item.appendChild(value);
						item.appendChild(separation);
						return symmetryList.appendChild(item);
					});
					symmetrySlideLabels.appendChild(symmetryList);
				}
				symmetrySlider.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise table mobile slider.
			const tableSliderMobile = document.getElementById('table-slider-mobile');
			if (tableSliderMobile) {
				noUiSlider.create(tableSliderMobile, {
					range: {
						'min': parseFloat(0),
						'max': parseFloat(100)
					},
					start: [parseFloat(0), parseFloat(100)],
					step: 1,
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 0, suffix: '%' }),
						wNumb({ thousand: ',', decimals: 0, suffix: '%' })
					],
				});

				//Initialise the search parameters with the values set.
				const __tableSliderMobile = tableSliderMobile.noUiSlider.get(true);
				if (__tableSliderMobile) {
					searchView.searchParams.table = {
						min: __tableSliderMobile[0],
						max: __tableSliderMobile[1]
					}
				}

				tableSliderMobile.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 0, suffix: '%' });
					const parent = parentsUntil(tableSliderMobile, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-table-slide-from-mobile')) {
						parent.querySelector('#display-table-slide-from-mobile').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-table-slide-to-mobile')) {
						parent.querySelector('#display-table-slide-to-mobile').value = formatter.to(parseFloat(values[1]));
					}
				});
				tableSliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.table = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise depth mobile slider.
			const depthSliderMobile = document.getElementById('depth-slider-mobile');
			if (depthSliderMobile) {
				noUiSlider.create(depthSliderMobile, {
					range: {
						'min': parseFloat(window.__depth.min),
						'max': parseFloat(window.__depth.max)
					},
					start: [parseFloat(0), parseFloat(100)],
					connect: true,
					tooltips: [
						wNumb({ thousand: ',', decimals: 2, suffix: '%' }),
						wNumb({ thousand: ',', decimals: 2, suffix: '%' })
					],
				});

				//Initialise the search parameters with the values set.
				const __depthSliderMobile = depthSliderMobile.noUiSlider.get(true);
				if (__depthSliderMobile) {
					searchView.searchParams.depth = {
						min: __depthSliderMobile[0],
						max: __depthSliderMobile[1]
					}
				}
				depthSliderMobile.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 2, suffix: '%' });
					const parent = parentsUntil(depthSliderMobile, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-depth-slide-from-mobile')) {
						parent.querySelector('#display-depth-slide-from-mobile').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-depth-slide-to-mobile')) {
						parent.querySelector('#display-depth-slide-to-mobile').value = formatter.to(parseFloat(values[1]));
					}
				});
				depthSliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.depth = {
						min: values[0],
						max: values[1]
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise polish slider.
			const polishSliderMobile = document.getElementById('polish-slider-mobile');
			if (polishSliderMobile) {
				noUiSlider.create(polishSliderMobile, {
					range: {
						'min': 0,
						'max': diamondsPolish.length
					},
					start: [0, diamondsPolish.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __polishSliderMobile = polishSliderMobile.noUiSlider.get(true);
				if (__polishSliderMobile) searchView.searchParams.polish = diamondsPolish.slice(parseInt(__polishSliderMobile[0]), parseInt(__polishSliderMobile[1])).map(i => i.value);
				const polishMobileSlideLabels = parentsUntil(polishSliderMobile, 'filter-inner').querySelector('.steps-labels');
				if (polishMobileSlideLabels) {
					const polishList = document.createElement('ul');
					diamondsPolish.map(c => {
						const item = document.createElement('li');
						item.style.width = `${(100 / diamondsPolish.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');

						const label = document.createElement('span');
						label.classList.add('label');
						label.innerText = c.label;

						const value = document.createElement('span');
						value.classList.add('value');
						value.innerText = c.value;

						item.appendChild(label);
						item.appendChild(value);
						item.appendChild(separation);
						return polishList.appendChild(item);
					});
					polishMobileSlideLabels.appendChild(polishList);
				}
				polishSliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.polish = diamondsPolish.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise symmetry slider.
			const symmetrySliderMobile = document.getElementById('symmetry-slider-mobile');
			if (symmetrySliderMobile) {
				noUiSlider.create(symmetrySliderMobile, {
					range: {
						'min': 0,
						'max': diamondsPolish.length
					},
					start: [0, diamondsPolish.length],
					connect: true,
					step: 1,
				});
				//Initialise the search parameters with the values set.
				const __symmetrySliderMobile = symmetrySliderMobile.noUiSlider.get(true);
				if (__symmetrySliderMobile) searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(__symmetrySliderMobile[0]), parseInt(__symmetrySliderMobile[1])).map(i => i.value);
				const symmetryMobileSlideLabels = parentsUntil(symmetrySliderMobile, 'filter-inner').querySelector('.steps-labels');
				if (symmetryMobileSlideLabels) {
					const symmetryList = document.createElement('ul');
					diamondsSymmetry.map(c => {
						const item = document.createElement('li');
						item.style.width = `${(100 / diamondsSymmetry.length)}%`
						const separation = document.createElement('span');
						separation.classList.add('separation');

						const label = document.createElement('span');
						label.classList.add('label');
						label.innerText = c.label;

						const value = document.createElement('span');
						value.classList.add('value');
						value.innerText = c.value;

						item.appendChild(label);
						item.appendChild(value);
						item.appendChild(separation);
						return symmetryList.appendChild(item);
					});
					symmetryMobileSlideLabels.appendChild(symmetryList);
				}
				symmetrySliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(values[0]), parseInt(values[1])).map(i => i.value);
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			//Initialise ratio slider.
			const ratioSliderMobile = document.getElementById('ratio-slider-mobile');
			if (ratioSliderMobile) {
				noUiSlider.create(ratioSliderMobile, {
					range: {
						'min': parseFloat(__ratio.min),
						'max': parseFloat(__ratio.max)
					},
					start: [parseFloat(0), parseFloat(9)],
					connect: true,
					tooltips: [true, true],
				});
				//Initialise the search parameters with the values set.
				const __ratioSliderMobile = ratioSliderMobile.noUiSlider.get(true);
				if (__ratioSliderMobile) {
					searchView.searchParams.ratio = {
						min: __ratioSliderMobile[0],
						max: __ratioSliderMobile[1]
					}
				}
				ratioSliderMobile.noUiSlider.on('update', (values, handle) => {
					const formatter = wNumb({ thousand: ',', decimals: 2 });
					const parent = parentsUntil(ratioSliderMobile, 'filter-inner');
					if (!parent) return false;

					if (parent.querySelector('#display-ratio-slide-from-mobile')) {
						parent.querySelector('#display-ratio-slide-from-mobile').value = formatter.to(parseFloat(values[0]));
					}

					if (parent.querySelector('#display-ratio-slide-to-mobile')) {
						parent.querySelector('#display-ratio-slide-to-mobile').value = formatter.to(parseFloat(values[1]));
					}
				});
				ratioSliderMobile.noUiSlider.on('set', (values, handle) => {
					searchView.searchParams.ratio = {
						min: values[0],
						max: values[1] 
					}
					searchView.resetOffset();
					searchView.updateSearch(true);
				});
			}

			window.priceSlider = priceSlider;
			window.caratSlider = caratSlider;
			window.ratioSlider = ratioSlider;
			window.ratioSliderMobile = ratioSliderMobile;
			window.tableSlider = tableSlider;
			window.rosiSlider = rosiSlider;
			window.tableSliderMobile = tableSliderMobile;
			window.depthSlider = depthSlider;
			window.depthSliderMobile = depthSliderMobile;
			window.colorSlider = colorSlider;
			window.fluorescenceSlider = fluorescenceSlider;
			window.fluorescenceSliderMobile = fluorescenceSliderMobile;
			window.intensitySlider = intensitySlider;
			window.claritySlider = claritySlider;
			window.cutSlider = cutSlider;
			window.polishSlider = polishSlider;
			window.polishSliderMobile = polishSliderMobile;
			window.symmetrySlider = symmetrySlider;
			window.symmetrySliderMobile = symmetrySliderMobile;

		}

	}
});

